// import $ from "jquery";
import { getRingPoolService } from "./function/getRingPoolService";
import { validacion } from "./utils/modal/validation";
import { HandleRingpool } from "./utils/modal/handleRingpool";
import { desActivarBTNSubmit } from "./utils/modal/handleBTNSubmit";
import { addStylesModal } from "./utils/modal/handleStylesModal";

/* import runDivisadero from './modalDivisadero';  */

//loadScript('"https://code.jquery.com/jquery-3.6.3.js" integrity="sha256-nQLuAZGRRcILA+6dMBOvcRh5Pe310sBpanc6+QBmyVM=" crossorigin="anonymous"')

(() => {
  if (typeof DFI === "undefined") {
    window.DFI = {};
    DFI.getQueryVariable = function (variable, url) {
      var href = url || window.location.search;
      var i, pair;
      var query = href.split("?")[1];
      var vars = query ? query.split("&") : [];

      for (i = 0; i < vars.length; i++) {
        pair = vars[i].split("=");

        if (pair[0] == variable && pair[1] !== "") return pair[1];
      }

      return "";
    };

    DFI.getUrlNoParams = function () {
      var pathnameUrl = window.location.pathname;
      var urlNotParams = pathnameUrl;
      return urlNotParams;
    };

    // Esta funcion se reemplazara por ---> DELIO.Mapfre.getSiteMapfre <--- en el archivo click2call.min.js
    // debido a que el nombre se repite desdde d1c y suele dar confuncion
    DFI.getSite = function () {
      let objProducto = {
        autocaravanas: [
          "autocaravanas",
          "Autocaravanas",
          "seguro-para-autocaravanas",
        ],
        caza_y_pesca: ["Caza y Pesca", "caza y pesca", "caza", "pesca"],
        coche: ["coche", "coches", "Coche", "Coches"],
        renting_coches: ["renting coches", "renting coche", "renting"],
        moto: ["moto", "motos", "Motos", "Moto"],
        salud: ["salud", "salud", "Salud", "Saluds"],
        vida: ["vida", "vidas", "Vida", "Vidas"],
        viajes: ["viajes", "viaje", "Viajes", "Viaje"],
        dental: ["dental", "Dental", "dentales", "Dentales"],
        bici: ["bici", "bicis", "Bici", "Bicis", "bicicletas", "Bicicletas"],
        hogar: [
          "hogar",
          "Hogar",
          "hogares",
          "propietarios",
          "propietario",
          "alquileres",
          "alquiler",
          "reformas",
          "reforma",
          "reparaciones",
          "reparacion",
        ],
        accidentes: ["accidente", "accidentes", "Accidente", "Accidentes"],
        decesos: ["decesos", "Decesos", "deceso", "Deceso"],
        mascotas: [
          "mascotas",
          "mascota",
          "Mascota",
          "Mascotas",
          "animales",
          "Animales",
          "animal",
        ],
        defensa_juridica: [
          "defensa juridica",
          "Defensa Juridica",
          "defensa",
          "juridica",
        ],
        objetos: ["objetos", "objeto", "Objeto", "Objetos"],
        embarcaciones: [
          "embarcacion",
          "Embarcacion",
          "embarcaciones",
          "Embarcaciones",
        ],
        alarmas_hogar: ["alarmas", "sistemas-de-alarmas", "alarma"],
      };

      let url = window.location.pathname;
      let resultado = "";

      // Recorrer las propiedades del objeto
      for (let propiedad in objProducto) {
        if (objProducto.hasOwnProperty(propiedad)) {
          // Recorrer el array asociado a la propiedad usando forEach
          objProducto[propiedad].forEach((elemento, indice) => {
            if (
              propiedad == "renting_coches" ||
              propiedad == "defensa_juridica"
            ) {
              if (propiedad == "renting_coches" && url.includes(elemento)) {
                resultado = "renting-coches";
              }
              if (propiedad == "defensa_juridica" && url.includes(elemento)) {
                resultado = "Defensa Juridica";
              }
            } else {
              if (url.includes(elemento)) {
                resultado = propiedad;
              }
            }
          });
        }
      }

      // if(resultado == "") resultado = "coche";

      return resultado;
    };

    DFI.loadScript = function (url, fn, docScope) {
      var doc = docScope || document;
      var head = doc.head || doc.getElementsByTagName("head")[0];
      var script = doc.createElement("script");
      script.src = url;
      script.type = "text/javascript";

      if (fn) script.addEventListener("load", fn);

      head.appendChild(script);
    };

    if (window.DFI.getQueryVariable("walmericTest") === "int") {
      window.DFI.loadScript(
        "https://t.womtp.com/slider/d/mapfre/es/click2call/dev/support/tarificadorClientesMapfre/build/clientesTarificador.js"
      );
      return;
    }
  }

  console.log("Entorno Mapfre Espana PRO");
  /* import runDivisadero from './modalDivisadero'; */
  /* Funciones nuevas clientes*/
  /* DELIO.Mapfre.loadScript = function(url, fn, docScope) {
    
        var doc     = docScope || document;
        var head    = doc.head || doc.getElementsByTagName("head")[0];
        var script  = doc.createElement("script");
        script.src  = url;
        script.type = "text/javascript";
    
        if(fn)
            script.addEventListener('load', fn);
    
        head.appendChild(script);
    }; */

  /* import runDivisadero from './modalDivisadero';  */

  //loadScript('"https://code.jquery.com/jquery-3.6.3.js" integrity="sha256-nQLuAZGRRcILA+6dMBOvcRh5Pe310sBpanc6+QBmyVM=" crossorigin="anonymous"')

  (function (newFunctionality) {
    let urlData = new URL(window.location.href);
    let origen_data = urlData.searchParams.get("origen");
    let elementFromOrigen = document.getElementsByName("c_var_26");

    if (
      origen_data != null &&
      origen_data != undefined &&
      origen_data != "undefined"
    ) {
      window.c_var_26 = origen_data;

      elementFromOrigen.forEach((input) => {
        input.value = origen_data;
      });
    }

    // if(DELIO.Mapfre.getProduct().toLowerCase() =="mascotas" || DELIO.Mapfre.getProduct().toLowerCase() == "mascota"){
    //     document.querySelector("#mp-header > div.contact.col-xs-6.col-sm-4.col-md-3.pull-right").style.visibility="hidden";
    // }
    window.womtp = window.womtp || {};
    window.womtp.c_vars = window.womtp.c_vars || [];

    window.idlead = "";
    var DelioTemplates;
    var DCS_header;
    var dmvPromise;

    window.ringPoolSchedule = DELIO.Mapfre.validator.scheduleValid({
      initDay: 1,
      finishDay: 5,
      initHour: 9,
      finishHour: 21,
    });

    window.modalVidaSchedule = DELIO.Mapfre.validator.scheduleValid({
      initDay: 1,
      finishDay: 5,
      initHour: 8,
      finishHour: 19,
    });

    var MapfreTemplates = {
      header: {},
      bottom: {},
    };

    let device = "COMPUTER";
    if (isMobile()) {
      device = "MOBILE";
      if (isTablet()) {
        device = "TABLET";
      }
    }

    //flag para carga del chat en 1click
    window.chatDevice = {
      device,
    };

    //tag que tienen que ser los mismos que en las LP, modifico aqui en vez de en el global para limitar el alcance del cambio a sitios inesperados.
    (DELIO.Mapfre.global.idTagVisit = "d3795c7889a89c2af249c3baf07a499b"),
      (DELIO.Mapfre.global.idTagConversion =
        "55d42605642e2c273277c7d2fad0351b"),
      (DELIO.Mapfre.global.idTagDelioClient =
        "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953abe4cb254380fee21da1e87e8c82a173c2256c0940ada1f402a8e36cb8005bad32093067d94cc4675fdd384b4cf3b0d3ef3a564a38ac549f13962d8757b81ddc8911cbae277739299386b326957a5d502"),
      newFunctionality();

    DELIO.Mapfre.setVisitVars();
    DELIO.Mapfre.setConversionVars();
    DELIO.Mapfre.loadScript(
      "https://t.womtp.com/js/otg.min.js?idtag=" +
      DELIO.Mapfre.global.idTagVisit
    );
    DELIO.Mapfre.getVisitorId(function (idVisitor) {
      window.Walmeric_leadid = idVisitor;

      //set default visit chat
      var wsVisitVars =
        "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html";

      var v_vars_obj = [
        {
          id: "11",
          value: device,
        },
        {
          id: "15",
          value: "NO",
        },
        {
          id: "16",
          value: "NO",
        },
        {
          id: "17",
          value: "NO",
        },
      ];
      window.v_vars = v_vars_obj;

      if (
        window.site == "coche" ||
        window.site == "moto" ||
        window.site == "autos"
      ) {
        DELIO.visit18 = 0;
        var chargeVisit = setInterval(function () {
          if (
            DELIO.Mapfre.newFuncionality.getStep() != DELIO.visit18 &&
            window.DAL
          ) {
            clearInterval(chargeVisit);
            DELIO.visit18 = DELIO.Mapfre.newFuncionality.getStep();
            v_vars_obj = [
              {
                id: "18",
                value:
                  DELIO.Mapfre.step[DELIO.Mapfre.getProduct().toLowerCase()][
                  DELIO.Mapfre.newFuncionality.getStep()
                  ],
              },
            ];
            visitSetVisitVars(
              wsVisitVars,
              v_vars_obj,
              womtp.idTag,
              window.Walmeric_leadid
            );
          }
        }, 5000);

        DELIO.vVar16 = true;
        DELIO.vVar17 = true;
        var dalCharge = setInterval(function () {
          if (window.DAL) {
            clearInterval(dalCharge);
            if (chekLandTimeToSetVisitVars()) {
              visitSetVisitVars(
                wsVisitVars,
                v_vars_obj,
                womtp.idTag,
                window.Walmeric_leadid
              );
            }
          }
        }, 50);

        //delio1click siempre carga y luego borra el chat, por eso este tiemout
        DELIO.setConVar16 = false;
        if (localStorage.getItem("leadChat")) {
          var intVentaChat = setInterval(function () {
            if (window.ventaChat === false) {
              setVentaChat(); //comprobamos si es el paso de venta
            } else {
              clearInterval(intVentaChat);
            }
          }, 4000);
        }
        //Escribo en otro fichero un log con la disponibilidad de sala.

        //Comprobando la visibilidad de SIO con respecto a css
        let CheckSioVis = setInterval(function () {
          if (
            document.getElementById("sio-chat") &&
            typeof document.getElementById("sio-chat") != null
          ) {
            clearInterval(CheckSioVis);
            if (document.getElementById("sio-chat").classList.length > 1) {
              visitSetVisitVars(
                "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
                [
                  { id: "16", value: "SI" },
                  { id: "15", value: "SI" },
                ],
                womtp.idTag,
                window.Walmeric_leadid
              );
            } else {
              if (
                document.getElementById("dsa") &&
                document.getElementById("dsa").style.display === "block" &&
                typeof document.getElementById("dsa") != undefined
              ) {
                visitSetVisitVars(
                  "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
                  [{ id: "15", value: "SI" }],
                  womtp.idTag,
                  window.Walmeric_leadid
                );
              }
            }
          }
        }, 1000);

        var contIntervalVisitVars = 0;
        var intervalVisitVars = setInterval(function () {
          const chat = document.querySelectorAll(".dChatUp");
          if (window.SIO && window.DAL) {
            let chatHidden = isHidden(chat);

            if (SIO.Chat.showDsa || !chatHidden) {
              if (SIO.Chat.showDsa) {
              } else {
                DAL.Ajax({
                  type: "jsonp",
                  url: "https://ws.walmeric.com/provision/wsVars/getVar.html",
                  data: {
                    idTag:
                      "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aad40da14f6914cc89bf63a3be3f2842729b998cd444dd757a59c6f362458f92cbf8298dcb3a0048adb75a251e0b1f4fbd938eb1c5a9b005aaef3b2ea6e8473324cae0070166d970294110c76a4f8657a",
                    name: "testChat29",
                  },
                }).done(function (dataResp) {
                  var date = new Date();
                  DAL.Ajax({
                    type: "jsonp",
                    url:
                      "https://ws.walmeric.com/provision/wsVars/setVar.html?idTag=29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aad40da14f6914cc89bf63a3be3f2842729b998cd444dd757a59c6f362458f92cbf8298dcb3a0048adb75a251e0b1f4fbd938eb1c5a9b005aaef3b2ea6e8473324cae0070166d970294110c76a4f8657a&name=testChat29&value=" +
                      dataResp.value +
                      "///" +
                      date +
                      " ERROR SIO-id:" +
                      Piwik.getAsyncTracker().getVisitorId() +
                      "device:" +
                      device,
                  }).done(function (dataResp) {
                    console.log(dataResp);
                  });
                });
              }

              if (!chatHidden) {
              } else {
                DAL.Ajax({
                  type: "jsonp",
                  url: "https://ws.walmeric.com/provision/wsVars/getVar.html",
                  data: {
                    idTag:
                      "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aad40da14f6914cc89bf63a3be3f2842729b998cd444dd757a59c6f362458f92cbf8298dcb3a0048adb75a251e0b1f4fbd938eb1c5a9b005aaef3b2ea6e8473324cae0070166d970294110c76a4f8657a",
                    name: "testChat29",
                  },
                }).done(function (dataResp) {
                  var date = new Date();
                  DAL.Ajax({
                    type: "jsonp",
                    url:
                      "https://ws.walmeric.com/provision/wsVars/setVar.html?idTag=29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aad40da14f6914cc89bf63a3be3f2842729b998cd444dd757a59c6f362458f92cbf8298dcb3a0048adb75a251e0b1f4fbd938eb1c5a9b005aaef3b2ea6e8473324cae0070166d970294110c76a4f8657a&name=testChat29&value=" +
                      dataResp.value +
                      "///" +
                      date +
                      " ERROR IS HIDDEN-id:" +
                      Piwik.getAsyncTracker().getVisitorId() +
                      "device:" +
                      device,
                  }).done(function (dataResp) {
                    console.log(dataResp);
                  });
                });
              }
              DELIO.openChat = false;
              window.ventaChat = false;
              clearInterval(intervalVisitVars);
              var v_vars_15 = [{ id: "15", value: "SI" }];
              console.log("si está desplegado también debería pasar por aquí");

              visitSetVisitVars(
                wsVisitVars,
                v_vars_15,
                womtp.idTag,
                window.Walmeric_leadid
              );
              var actualPage = "";
              var flagCodPresupuesto = true;
              setInterval(function () {
                try {
                  if (actualPage !== window.nombre_pagina) {
                    if (
                      window.nombre_pagina ===
                      "20_Pantalla_datos_contacto_tomador"
                    ) {
                      //el chat les tapa un botón suyo en este paso
                      document.querySelector("#dsa").style.marginTop = "5em";
                    } else {
                      document.querySelector("#dsa").style.marginTop = "0px";
                    }
                  }
                } catch (error) {
                  console.log(error);
                }
                var codPresupuesto = "";
                if (
                  DELIO.Mapfre.newFuncionality.getStep() == 2 &&
                  flagCodPresupuesto &&
                  DELIO.openChat
                ) {
                  flagCodPresupuesto = false;
                  var codPresupuesto = "";
                  if (
                    typeof window.cod_presupuesto != "undefined" &&
                    window.cod_presupuesto != "" &&
                    window.cod_presupuesto != "undefined"
                  ) {
                    codPresupuesto = window.cod_presupuesto;
                  } else {
                    try {
                      if (
                        ~window.location.href.indexOf("calcular-seguros-coche")
                      ) {
                        codPresupuesto = digitalData.quotation_id;
                        if (typeof codPresupuesto == "undefined") {
                          codPresupuesto = "";
                        }
                      } else {
                        codPresupuesto = JSON.parse(
                          localStorage.getItem("autosData")
                        ).dataModel.numPresupuestoRUP;
                        if (typeof codPresupuesto == "undefined") {
                          codPresupuesto = "";
                        }
                      }
                    } catch (error) {
                      codPresupuesto = "";
                    }
                  }
                  updateChat({
                    EDeclaratives: { cod_presupuesto: codPresupuesto },
                  });
                }
              }, 1000);
            }
          }

          if (contIntervalVisitVars == 30) {
            clearInterval(intervalVisitVars);
          }
          contIntervalVisitVars++;
        }, 200);

        function visitSetVisitVars(
          wsVisitVars,
          v_vars_obj,
          idTag,
          leadid,
          callback
        ) {
          DAL.Ajax({
            type: "jsonp",
            url: wsVisitVars,
            data: {
              data: encodeURIComponent(JSON.stringify(v_vars_obj)),
              idTag: idTag,
              idVisitor: leadid,
              format: "jsonp",
            },
          }).done(function (dataResp) {
            //console.log("set visit default visit vars");
            if (callback) {
              setTimeout(() => {
                //Timeout para asegurarnos que se graba la etiqueta de visita 15 en el back antes de cargar d1c
                callback();
              }, 200);
            }
          });
        }

        function chekLandTimeToSetVisitVars() {
          if (localStorage.getItem("landTime")) {
            var landTime = Date.parse(localStorage.getItem("landTime"));
            var hoy = new Date();

            var pastTime = hoy - landTime;
            var segs = 1000;
            var mins = segs * 60;
            var hours = mins * 60;
            var days = hours * 24;
            var months = days * 30.416666666666668;
            var years = months * 12;

            var years = Math.floor(pastTime / years);

            pastTime = pastTime - years * years;
            var meses = Math.floor(pastTime / months);

            pastTime = pastTime - meses * months;
            var days = Math.floor(pastTime / days);

            pastTime = pastTime - days * days;
            var hours = Math.floor(pastTime / hours);

            pastTime = pastTime - hours * hours;
            var mins = Math.floor(pastTime / mins);

            if ((years || meses || days || hours) > 0) {
              localStorage.setItem("landTime", new Date());
              return true;
            } else if (mins <= 31) {
              return false;
            } else {
              localStorage.setItem("landTime", new Date());
              return true;
            }
          } else {
            localStorage.setItem("landTime", new Date());
            return true;
          }
        }

        function isHidden(el) {
          if (el === null || el.length === 0) {
            return true;
          }

          var output = true;

          for (var i = 0, len = el.length; i < len; i++) {
            var style = window.getComputedStyle(el[i]);
            if (style.display != "none" && style.visibility != "hidden") {
              output = false;
            }
            if (style.display === "inline" && el[i].offsetParent === null) {
              output = false;
            }
          }

          return output;
        }
      }

      if (
        window.site == "salud" &&
        ~location.href.indexOf(
          "wmapfre.pre.mapfre.net/calcular-seguro-salud-global/"
        )
      ) {
        runDivisadero();
      }

      function setVentaChat() {
        if (~location.href.indexOf("#/autos/policy")) {
          updateSale("retorno pasarela de pago de REDSYS");
        } else if (~location.href.indexOf("#/autos/paypalok")) {
          updateSale("retorno pasarela de pago con PayPal");
        } else if (~location.href.indexOf("#/autos/fin-contratacion")) {
          updateSale("emisión OK");
        } else if (~location.href.indexOf("#/autos/emision-incompleta")) {
          updateSale("emisión KO");
        }
      }

      function updateSale(data) {
        window.ventaChat = true;
        if (typeof SIO.Chat.storage().wm_user != "undefined") {
          var dataUpdateChat = {
            EConversions: [{ id: "17", value: data }],
          };

          dataUpdateChat = JSON.stringify(dataUpdateChat);

          var idLead = localStorage.getItem("leadChat");

          DAL.Ajax({
            type: "jsonp",
            url: "https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html",
            data: {
              data: dataUpdateChat,
              idTag: DELIO.Mapfre.global.idTagDelioClient,
              leadId: idLead,
            },
          }).done(function (dataResp) {
            console.log("DFI.updateLead() => resp", dataResp);
            localStorage.removeItem("leadChat");
          });
        }
      }
    });

    // No continuar desplegando servicios en "Bicicleta" y "Accidentes"

    if (
      DELIO.Mapfre.getProduct() === "Bicicleta" ||
      DELIO.Mapfre.getProduct() === "Accidentes"
    ) {
      return false;
    }

    //lanzo el listener del cambio de step del form
    DELIO.Mapfre.newFuncionality.angularDatalayerListener();

    window.gracias = function (data) {
      if (data.result == "OK") {
        var conversionTag =
          "https://t.womtp.com/js/otg.min.js?idtag=" +
          DELIO.Mapfre.global.idTagConversion +
          "&orderid=" +
          data.leadId;
        DELIO.Mapfre.loadScript(conversionTag);
      }
    };

    var addOneCLick = true;
    var origen = DELIO.Mapfre.getQueryVariable("origen");
    //Con este parametro por url no se muestra chat
    if (
      origen === "WALLAPO" ||
      origen === "WALLAPO/" ||
      origen === "MOVISTA" ||
      origen === "MOVISTA/"
    ) {
      localStorage.setItem("noShowChat", true);
      addOneCLick = false;
    } else {
      addOneCLick = true;
    }

    //En estas urls no nos mandan parametro origen por lo que controlamos si se muestra o no el chat
    if (
      localStorage.getItem("noShowChat") &&
      (~location.href.indexOf("paypalok") ||
        ~location.href.indexOf("paypalko") ||
        ~location.href.indexOf("policy") ||
        ~location.href.indexOf("fin-contratacion"))
    ) {
      addOneCLick = false;
      localStorage.setItem("pageChat", document.location.href);
    }

    //Controlo que recarguen la página en estas urls
    if (localStorage.getItem("pageChat")) {
      if (localStorage.getItem("pageChat") === document.location.href) {
        addOneCLick = false;
      }
    }

    if (window.site === "coche" && addOneCLick) {
      // if (isMobile()) {
      //no cargamos chat
      //} else {
      addDelio1click();
      addChatParams();
      localStorage.removeItem("noShowChat");
      localStorage.removeItem("pageChat");
      //}
    }

    function isMobile() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);

      if (window.matchMedia("(orientation: portrait)").matches) {
        if (screen.width > 767) {
          check = false;
        }
      }

      if (window.matchMedia("(orientation: landscape)").matches) {
        if (screen.height > 767) {
          check = false;
        }
      }
      return check;
    }

    function isTablet() {
      const userAgent = navigator.userAgent.toLowerCase();
      return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent
      );
    }

    DELIO.Mapfre.currentStep;
    function trackChat() {
      if (window.site == "coche") {
        try {
          if (
            typeof window.nombre_pagina != "undefined" &&
            window.nombre_pagina != DELIO.Mapfre.currentStep
          ) {
            DELIO.Mapfre.currentStep = window.nombre_pagina;
            lastMessage = SIO.Chat.storage().wm_lastMessageTime.toString();
            var send = {
              EConversions: [
                {
                  id: "19",
                  value: window.nombre_pagina.substr(
                    window.nombre_pagina.indexOf("_") + 1
                  ),
                },
              ],
            };
            updateChat(send);
          }
        } catch (error) { }
      }
    }

    function updateChat(data) {
      var dataUpdateChat = JSON.stringify(data);
      var idlead = SIO.Chat.global.leadId || SIO.Chat.storage().wm_user;
      DAL.Ajax({
        type: "jsonp",
        url: "https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html",
        data: {
          data: dataUpdateChat,
          idTag: DELIO.Mapfre.global.idTagDelioClient,
          leadId: idlead,
        },
      }).done(function (dataResp) {
        console.log("DFI.updateLead() => resp", dataResp);
      });
    }

    /*
        |---------------------------------------------------------------------------
        | ComprobaciÃ³n de la carga de los elementos del interfaz
        |---------------------------------------------------------------------------
        */

    var elementsLoaded = new Promise(function (resolve) {
      var checkElementsLoaded = setInterval(function () {
        if (
          document.querySelector(".hero-controller") ||
          document.querySelector(".btn-walmeric")
        ) {
          /* Si existe clase banner en popup cookies lo eliminamos */
          clearInterval(checkElementsLoaded);

          /*  var btncookies = document.querySelector('#ot-sdk-btn');
                    if (btncookies && btncookies.classList.contains('banner')) {
                        btncookies.classList.remove('banner');
                    } */
          resolve();
        }
      }, 500);
    });

    /*
        |---------------------------------------------------------------------------
        | Carga de DAL, los templates y el style
        |---------------------------------------------------------------------------
        */
    // elementsLoaded.done(function () { //Eliminar esta linea de codigo cuando se retire jQuery
    elementsLoaded.then(function () {
      DelioTemplates = getDelioTemplates();

      var showRingPool = setInterval(function () {
        if (document.querySelector(".DCS-bodyRpContainer") != null) {
          clearInterval(showRingPool);
        }
      }, 200);

      MapfreTemplates.header.container =
        document.getElementsByClassName("mfc-header__content")[0] ||
        document.getElementsByClassName("container")[0];

      MapfreTemplates.header.logo =
        document.getElementsByClassName("content-logo")[0] ||
        document.getElementsByClassName(
          "mfc-header__content__main__logo ng-scope"
        )[0];

      MapfreTemplates.header.msj =
        document.getElementsByClassName("link")[0] ||
        document.getElementsByClassName("mfc-header__content__contact")[0];

      MapfreTemplates.bottom.msj = document.getElementsByClassName(
        "mfc-link-button__green"
      )[0];

      document.body.addEventListener("click", function (event) {
        if (window.DRP) {
          DRP.loadConversions();
        }
      });

      DELIO.Mapfre.loadScript(DELIO.Mapfre.global.dal, function () {
        stylesPromise = DAL.Promise();
        dmvPromise = DAL.Promise();

        DAL.Ajax({ type: "style", url: DELIO.Mapfre.global.styles }).done(
          stylesPromise.resolve
        );

        paintButtons();

        checkInterfaceChanges();

        updateGaBackEnd();
        if (window.location.href.includes("particulares")) {
          interceptarBtnWalmeric();
        }

        if (DELIO.Mapfre.getProduct() == "Ahorro") {
          checkChangeStep();
        }
      });
    });

    function checkChangeStep() {
      var stepAct = DELIO.Mapfre.newFuncionality.getStep();
      var origen = DELIO.Mapfre.getQueryVariable("origen");
      var removeModalList = false;
      var btn = document.getElementsByClassName("DCS-ClickToCall")[0];

      if (origen != "PI") {
        setInterval(function () {
          var stepNext = DELIO.Mapfre.newFuncionality.getStep();
          if (
            (stepAct != stepNext && stepNext != undefined) ||
            (stepAct == 7 && !removeModalList)
          ) {
            stepAct = stepNext;

            var tuplanEl = document.getElementById("tuPlan");

            if (
              !tuplanEl &&
              typeof D3P.Modal != "undefined" &&
              !removeModalList
            ) {
              document.querySelector(".cdk-overlay-container").style.display =
                "initial";

              if (btn) {
                btn.removeEventListener("click", ahorroFuncModal);
                removeModalList = true;
              }
            }
          }
        }, 1000);
      }
    }

    /*
        |---------------------------------------------------------------------------
        | updateGaBackEnd
        |---------------------------------------------------------------------------
        */
    function updateGaBackEnd() {
      // Tracking_ google analitics
      var idVisitor;
      var piwikPromise;

      DELIO.Mapfre.getVisitorId(function (visitorId) {
        window.gaCookie = DELIO.Mapfre.getCookie("_ga");

        var url =
          "https://t.womtp.com/epst" +
          "?idsite=" +
          DELIO.Mapfre.global.idTagDelioClient +
          "&idvisitor=" +
          visitorId +
          "&gaid=" +
          window.gaCookie;

        console.log("Tracking GA URL " + url);

        DAL.Ajax({
          type: "jsonp",
          url: url,
        });
      });
    }

    /*
        |---------------------------------------------------------------------------
        | overMapfreButton: repinta cualquier elemento con nuestro gurrumino
        | Recibe los productos donde queremos tener esta funcionalidad, y la clase o id
        | de los que nos facilita mapfre
        |---------------------------------------------------------------------------
        */

    const overMapfreButton = (products, blockToStepOn) => {
      products.forEach((product) => {
        blockToStepOn.forEach((block) => {
          if (document.querySelector(block) && product == window.site) {
            MapfreTemplates.header.container = document.querySelector(block);
            MapfreTemplates.header.container.innerHTML = "";
            MapfreTemplates.header.container.style.border = "none";
            return true;
          }
        });
      });
    };

    /*
        |---------------------------------------------------------------------------
        | Paint Buttons
        |---------------------------------------------------------------------------
        */
    window.paintButtons = function () {
      var timer = 10;
      var es_ie = navigator.userAgent.indexOf("MSIE") > -1;
      if (es_ie) {
        timer = 700;
      }

      if (window.site == "viajes") {
        if (
          !(
            location.href.indexOf(
              "calcular-seguro-viaje/es/motivo-viaje?origen=PSNP&PPPO=PSNP"
            ) > -1
          )
        ) {
          console.log("In viajes");

          const banner = document.querySelector(".banner");
          if (banner && typeof banner != undefined) {
            document.querySelector(".banner").innerHTML = "";

            var btn = document.createElement("div");

            btn.style.display = "block";

            btn.innerHTML =
              '<div class="DCSS-c2c" style="width:100%;margin-bottom: 15px;">\
                                    <div class="DCS-ClickToCall" style="padding:0;">\
                                        <div class="DCS-imageClickToCall" style="margin:0;font-size:15px;padding: 7px;display: flex;max-width: none; align-items: center;justify-content: center;border: 1px solid #e9ebec;background: #d10000;border-radius: 8px;">\
                                            <!--<img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/call-you-negative.jpg">-->\
                                            <a href style="border-bottom: none; color: #fff;text-decoration: none;">\
                                            Déjanos tus datos y te <br> llamaremos lo antes posible\
                                            </a>\
                                        </div>\
                                    </div>\
                                </div>\
                    ';
            document.querySelector(".banner").appendChild(btn);

            document.querySelector(".banner").style.textAlign = "center";
            document.querySelector(".banner").style.padding = "10px 5px";

            var elem = document.getElementsByClassName("DCS-ClickToCall")[0];
          }
        }
      }

      if (window.site == "mascotas") {
        document.querySelector("#mp-header").className += " header-mascotas";

        document.querySelector(".headerPhone").innerHTML = "";

        document.querySelector(".headerCall").style.display = "none";

        let botonMascota = document.createElement("div");

        botonMascota.style.display = "block";

        botonMascota.innerHTML =
          '<div class="DCSS-c2c" style="width:100%;margin-bottom: 10px;">\
                                <div class="DCS-ClickToCall" style="padding:0;margin: 0 18px !important;">\
                                    <div class="DCS-imageClickToCall" style="margin: 0;font-size:15px;padding: 7px;display: flex;max-width: none; align-items: center;justify-content: center;border: 1px solid #e9ebec;border-radius: 8px;">\
                                        <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/call-you-negative.jpg" style="width: 21px;margin-right: 5px;">\
                                        <a href style="border-bottom: none;text-decoration: none;">\
                                            Déjanos tus datos y te <br> llamaremos lo antes posible\
                                        </a>\
                                    </div>\
                                </div>\
                            </div>\
                ';
        document.querySelector(".headerPhone").appendChild(botonMascota);

        document.querySelector(".headerPhone").style.textAlign = "center";
        document.querySelector(".headerPhone").style.padding = "10px 5px";

        let elem = document.getElementsByClassName("DCS-ClickToCall")[0];
      }

      // producto ahorro no interfiere boton segun siguientes casuisticas
      var origen = DELIO.Mapfre.getQueryVariable("origen");
      if (window.site == "ahorro" && origen == "PI") {
        return false;
      }

      setTimeout(function () {
        var ourButtons = document.querySelector(".DCSS-c2c");

        if (
          ourButtons &&
          !window.site == "mascotas" &&
          !window.site == "ahorro"
        ) {
          return false;
        }

        MapfreTemplates.header.container =
          document.getElementsByClassName("mfc-header__content")[0] ||
          document.getElementsByClassName("container")[0] ||
          document.querySelector(".banner");

        MapfreTemplates.header.logo =
          document.getElementsByClassName("content-logo")[0] ||
          document.getElementsByClassName(
            "mfc-header__content__main__logo ng-scope"
          )[0];

        MapfreTemplates.header.msj =
          document.getElementsByClassName("link")[0] ||
          document.getElementsByClassName("mfc-header__content__contact")[0];

        MapfreTemplates.bottom.msj = document.getElementsByClassName(
          "mfc-link-button__green"
        )[0];

        //cargar boton del header
        if (
          MapfreTemplates.header.msj &&
          MapfreTemplates.header.msj.parentNode
        ) {
          MapfreTemplates.header.msj.parentNode.removeChild(
            MapfreTemplates.header.msj
          );
        }

        // Repintamos el boton de mapfre
        if (
          window.site == "bici" ||
          window.site == "dental" ||
          window.site == "lex" ||
          window.site == "decesos" ||
          window.site == "comunidades"
        ) {
          overMapfreButton(
            ["bici", "dental", "lex", "decesos", "comunidades"],
            [
              "#contact-container",
              "#callCenter",
              ".sprite-bgCabecera .contact",
              ".container-tlf",
            ]
          );
        }

        //boton sin RP
        var template = document.createElement("div");
        template.innerHTML = DelioTemplates.header({
          msj: "Déjanos tus datos y te <br> llamaremos lo antes posible",
        });
        window.button = template.firstElementChild;
        if (MapfreTemplates.header.container) {
          MapfreTemplates.header.container.appendChild(
            template.firstElementChild
          );
        }

        //boton con RP
        var templateRP = document.createElement("div");
        templateRP.innerHTML = DelioTemplates.header_rp({
          msj: "Déjanos tus datos y te <br> llamaremos lo antes posible",
        });
        window.buttonRP = templateRP.firstElementChild;
        if (MapfreTemplates.header.container) {
          MapfreTemplates.header.container.appendChild(
            templateRP.firstElementChild
          );
        }

        // Ajustes estilos Gurrumino
        if (
          (window.site == "bici" ||
            window.site == "dental" ||
            window.site == "lex") &&
          document.querySelector(".DCSS-c2c") != undefined
        ) {
          document.querySelector(".DCSS-c2c").style.left = "13px";
          document.querySelector(".DCSS-c2c").style.zIndex = "9999";
        }

        // Este condicional podemos quitarlo, ya que el formulario no depende de estas clases.
        if (
          window.site == "decesos" &&
          typeof document.querySelector(".DCSS-c2c") != undefined &&
          document.querySelector(".DCS-ClickToCall")
        ) {
          document.querySelector(".DCS-ClickToCall").style.display = "flex";
        }

        if (
          window.site == "comunidades" &&
          typeof document.querySelector(".DCSS-c2c") != undefined
        ) {
          document.querySelector(".DCS-ClickToCall").style.cssText =
            "display: flex; align-items: center;justify-content: space-between;position: relative;right: 2rem;";
          document.querySelector(".DCS-imageClickToCall").style.cssText =
            "display: flex;justify-content: center;";
          document.querySelector(".DCS-textClickToCall").style.cssText =
            "display: flex; padding-right:8px;";
          document.querySelector(".lateral > li").style.display = "none";
        }

        if (
          ~location.href.indexOf("calcular-pension") ||
          ~location.href.indexOf("TarificadorContratadorDecesos_fe-web")
        ) {
          button.classList.add("DCSS-c2c--pensiones");
          document.querySelector(
            ".mfc-header .mfc-header__content"
          ).style.padding = "12px 10px";
        }

        if (
          window.site == "accidentes" &&
          document.querySelector(".DCS-ClickToCall")
        ) {
          document.querySelector(".DCSS-c2c").style.marginTop = "-8px";
        }

        // iniciar rp
        if (ringPoolSchedule) {
          var rpTop = document.getElementById("ringpool-top");
          if (rpTop) {
            rpTop.target = "_blank";
          }
          DELIO.drpCharge = false; //flag de test
          if (location.href.indexOf("calcular-seguro-hogar") > 0) {
            //mejora ringpool
            DELIO.initRingPool = false;
            if (DELIO.drpCharge === false) {
              DELIO.drpCharge = true;
              DAL.Ajax({ type: "jsonp", url: DELIO.Mapfre.global.ringPool });
            }
          } else {
            loadRingPool(["#ringpool-top", ".drp-phone"]);
          }
        }

        // cargar la modal
        DAL.Ajax({ type: "script", url: DELIO.Mapfre.global.dmv }).done(
          dmvPromise.resolve
        );
        DAL.Promise.all([stylesPromise, dmvPromise]).done(loadModalView);

        // quitar el telefono del footer
        toggleButtons(window.button, window.buttonRP);

        if (window.site == "mascotas") {
          var currentButton = button || window.button;
          var currentButtonRP = buttonRP || window.buttonRP;

          currentButtonRP.style.display = "none";
          currentButton.style.display = "none";
        }
      }, timer);
    };

    /*
        |---------------------------------------------------------------------------
        | Cambia el boton visible
        |---------------------------------------------------------------------------
        */
    window.toggleButtons = function (button, buttonRP) {
      var currentButton = button || window.button;
      var currentButtonRP = buttonRP || window.buttonRP;

      if (DELIO.Mapfre.newFuncionality.getIsRP()) {
        currentButton.style.display = "none";
        currentButtonRP.style.display = "block";
      } else {
        currentButton.style.display = "block";
        currentButtonRP.style.display = "none";
      }

      if (window.site == "mascotas") {
        if (DELIO.Mapfre.newFuncionality.getIsRP()) {
          currentButton.style.display = "none";
          currentButtonRP.style.display = "none";
        } else {
          currentButton.style.display = "none";
          currentButtonRP.style.display = "none";
        }
      }
    };

    /*
        |---------------------------------------------------------------------------
        | Check Interface Changes
        |---------------------------------------------------------------------------
        */
    function checkInterfaceChanges() {
      //comprobacion de repintado del boton de la cabecera
      var showRP = DELIO.Mapfre.newFuncionality.getIsRP();
      var c2c;
      var refreshButtonsElement;
      var buttonOutSchedule;
      var title_resumenPresupuesto = false;
      var intervalCheckChanges = setInterval(function () {
        // boton "Te llamamamos"
        c2c = document.querySelector(".DCSS-c2c");

        if (c2c) {
          c2c.addEventListener("click", function (e) {
            window.diferenciarModalTipo = "Callme_tarificador";
            if (site == "hogar" && !e.isTrusted) {
              window.diferenciarModalTipo = "Callme_tarificador_gestión_error";
            }
          });
        }

        //si no estamos
        isRefreshButtonsElement = !c2c;
        //compruebo si el showRP anterior es diferente al actual, si es así­ repinto
        if (showRP !== DELIO.Mapfre.newFuncionality.getIsRP()) {
          showRP = DELIO.Mapfre.newFuncionality.getIsRP();
          toggleButtons();
        }

        //repinto los botones en este step porque ellos nos pisan el boton
        if (
          (site == "salud" && isRefreshButtonsElement) ||
          (site == "hogar" && isRefreshButtonsElement) ||
          (site == "autos" && isRefreshButtonsElement) ||
          (site == "vida" && isRefreshButtonsElement) ||
          (site == "jubilacion" && isRefreshButtonsElement) ||
          (site == "viajes" && isRefreshButtonsElement) ||
          (site == "coche" && isRefreshButtonsElement) ||
          (site == "moto" && isRefreshButtonsElement) ||
          (site == "bici" && isRefreshButtonsElement) ||
          (site == "accidentes" && isRefreshButtonsElement) ||
          (site == "dental" && isRefreshButtonsElement) ||
          (site == "lex" && isRefreshButtonsElement) ||
          (site == "comunidades" && isRefreshButtonsElement) ||
          (site == "decesos" && isRefreshButtonsElement)
        ) {
          clearInterval(intervalCheckChanges);
          window.paintButtons();
        }

        var c2cAll = document.querySelectorAll(".DCSS-c2c");

        if (c2cAll.length > 1) {
          c2cAll.forEach((elem, ind) => {
            if (ind > 0) elem.remove();
          });
        }

        if (window.site === "viajes" && c2cAll.length > 0) {
          var c2cAllRingpool = document.querySelectorAll(".DCS-RP");
          if (c2cAllRingpool) {
            c2cAllRingpool.forEach((elem) => elem.remove());
          }
        }

        // Boton de Fuera de horario
        if (!buttonOutSchedule) {
          buttonOutSchedule = document.querySelector(
            "a[mfc-depend-name='botonServicioNoDisponible']"
          );

          if (buttonOutSchedule) {
            // Se repinta para quitar los eventos de Angular
            buttonOutSchedule.outerHTML = buttonOutSchedule.outerHTML;
            buttonOutSchedule = document.querySelector(
              "a[mfc-depend-name='botonServicioNoDisponible']"
            );
            c2c.style.visibility = "hidden";

            // Si existe le añadimos el evento click para abrir la modal de CallMe
            buttonOutSchedule.addEventListener("click", function (e) {
              e.preventDefault();
              D3P.Modal.open();
            });
          }
        }

        // [WCS-3294] Ocultar C2C en el paso de contratación
        var title = document.querySelector(".titulo");
        if (
          diasInvalidarC2CContratacion() &&
          !title_resumenPresupuesto &&
          title &&
          title.textContent.trim() === "Resumen del presupuesto"
        ) {
          // resument presupuesto encontrado
          title_resumenPresupuesto = true;
          // ocultar c2c
          c2c.style.visibility = "hidden";
        }
      }, 100);
    }

    /*
        |---------------------------------------------------------------------------
        | Este array de objeto se encarga de validar los botones de los formularios teniendo en cuenta los campos introducidos.
        | 
        |---------------------------------------------------------------------------
        */
    let ActivadorBTN = [
      {
        nombre: "Documento",
        value: false,
        errorText: "El DNI/NIE no es válido",
      },
      {
        nombre: "Telefono",
        value: false,
        errorText: "El teléfono no es válido",
      },
      {
        nombre: "Codigo_postal",
        value: false,
        errorText: "El código postal no es válido",
      },
      // { nombre: "email",             value: false, errorText: "El email no es válido" },
      // { nombre: "Nombre",            value: false, errorText: "El nombre no es válido" },
      // { nombre: "Apellidos",         value: false, errorText: "Los apellidos no son válidos" },
      // { nombre: "Compañía_actual",   value: false, errorText: "Tienes que seleccionar una opción" },
      // { nombre: "Vencimiento",       value: false, errorText: "La fecha de vencimiento no es válida" },
    ];

    /*
        |---------------------------------------------------------------------------
        | [WCS-3294]
        | Dias para ocultar el c2c en contratación 01/06 hasta las 20:00
        | - Enero es el mes 0
        |---------------------------------------------------------------------------
        */
    function diasInvalidarC2CContratacion() {
      var today = new Date();
      if (
        today.getDate() === 1 &&
        today.getMonth() === 5 &&
        today.getHours() < 20
      ) {
        return true;
      }
      return false;
    }

    /*
        |---------------------------------------------------------------------------
        | Mobile check
        |---------------------------------------------------------------------------
        */
    function mobilecheck() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    /*
        |---------------------------------------------------------------------------
        | Iniciar modal view.
        |---------------------------------------------------------------------------
        */
    function loadModalView() {
      var dmv = new DMV();
      D3P.Modal = dmv;

      var data = {};
      DELIO.Mapfre.newFuncionality.setExtraDeclaratives(data);
      if (ringPoolSchedule) {
        dmv.setContent(
          DelioTemplates.modalRingPool({
            title: "Déjanos tus datos y te <br> llamaremos lo antes posible",
            msj: "Si nos dejas tu n&uacute;mero de tel&eacute;fono, podemos llamarte tan pronto como nos sea posible",
          })
        );
      } else {
        dmv.setContent(
          DelioTemplates.modalRingPool({
            title: "Déjanos tus datos y te <br> llamaremos lo antes posible",
            msj: "Si nos dejas tu n&uacute;mero de tel&eacute;fono, podemos llamarte tan pronto como nos sea posible",
          })
        );
      }

      if (window.site == "ahorro") {
        dmv.setContent(
          DelioTemplates.modalSinRingPool({
            title: "Déjanos tus datos y te <br> llamaremos lo antes posible",
            msj: "Si nos dejas tu n&uacute;mero de tel&eacute;fono, podemos llamarte tan pronto como nos sea posible",
          })
        );
      }

      try {
        addListenerInputsNumber(document.querySelector("#DCS-phone"));
      } catch (error) {
        console.log(error);
      }

      try {
        validarCodigoPostal(document.querySelector("#DCS-CP"));
      } catch (error) {
        console.log("error codigo postal");
      }

      var btn = document.getElementsByClassName("DCS-ClickToCall")[0];
      if (btn) {
        if (window.site == "ahorro") {
          btn.addEventListener("click", ahorroFuncModal);
        } else {
          btn.addEventListener("click", function (e) {
            if (DELIO.initRingPool === false) {
              DELIO.initRingPool = true;
              loadRingPool(["#ringpool-top", ".drp-phone"]);
            }
            e.preventDefault();
            //addConVar16btn();

            if (
              window.site == "ahorro" &&
              document.querySelector(".cdk-overlay-container")
            ) {
              document.querySelector(".cdk-overlay-container").style.display =
                "none";
            }

            dmv.open();
          });
        }
      }

      // Revisar este bloque, ya no se guarda/recoge el cp con este id(cp)
      const CpInterval = setInterval(() => {
        if (window.location.toString().includes("salud")) {
          if (document.querySelector("#cp") != null) {
            clearInterval(CpInterval);

            document
              .getElementById("cp")
              .addEventListener("input", function (ev) {
                DELIO.Mapfre.datalayerInfo.cp = ev.currentTarget.value;
                //grabo en el session storage
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
              });
          }
        }
      }, 1000);

      dmv.on("open", function () {
        //ocultar el button de cierre por defecto.
        window.userLabels.EDeclaratives.publicidad_perfilada_aceptada = "no";
        document.getElementById("dmv-close").style.display = "none";

        var btnClose = document.getElementsByClassName(
          "DCS-headerFormClose"
        )[0];
        btnClose.addEventListener("click", dmv.close);

        var btnSend = document.getElementsByClassName(
          "DCS-footerFormButton"
        )[0],
          errorMsj1 = document.createElement("div");
        errorMsj2 = document.createElement("div");
        errorMsj3 = document.createElement("div");
        errorMsj4 = document.createElement("div");
        errorMsj5 = document.createElement("div");
        errorMsj1.style.display = "none";
        errorMsj2.style.display = "none";
        errorMsj3.style.display = "none";
        errorMsj4.style.display = "none";
        errorMsj5.style.display = "none";

        if (window.site == "viajes") {
          document.querySelector("#dmv-content").className += " modal-viajes";
        }

        if (window.site == "mascotas") {
          document.querySelector("#dmv-content").className += " modal-mascotas";
        }

        if (window.site == "ahorro") {
          document.querySelector("#dmv-content").className += " modal-ahorro";
        }

        if (window.site == "coche" || window.site == "moto") {
          if (!btnSend) return;
          btnSend.style.background = "#a9cb02";
        }

        if (window.site == "coche" || window.site == "moto" || window.site == "hogar") {
          const dateTimeContainer = document.getElementsByClassName("date_text")[0];
          dateTimeContainer.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
        }

        if (btnSend) {
          btnSend.addEventListener("click", function () {
            //recogida de datos del formulario
            var phoneEl = document.getElementById("DCS-phone"),
              phoneError;
            var cpEl = document.getElementById("DCS-CP"),
              cpError;
            // [WCS-3276] check deshabilitado
            //var checkEl = document.getElementById('DCS-check'), checkError;
            var nombreEl = document.getElementById("DCS-nombre"),
              nombreError;
            var fechaEl = document.getElementById("DCS-fecha"),
              fechaError;

            if (document.getElementById("DCS-formulario")) {
              var formularioEl = document.getElementById("DCS-formulario");
            }

            window.phone = phoneEl ? phoneEl.value : "";
            try {
              window.wm_cp = cpEl.value;
            } catch (error) { }
            try {
              window.wm_nombre = nombreEl.value;
            } catch (error) { }
            try {
              window.wm_fecha = fechaEl.value;
            } catch (error) { }
            try {
              window.wm_formulario = formularioEl.value;
            } catch (error) { }

            //validacion de los inputs
            try {
              phoneError = !DELIO.Mapfre.validator.phone(phoneEl.value);
            } catch (error) { }

            //Validacion CP Bois//
            var cpError = validarCodigoPostal(
              document.querySelector("#DCS-CP")
            );

            if (!cpError) {
              let cpErrElement = document.querySelector("#DCS-CP");
              if (!cpErrElement) return;
              errorMsj2.style.display = "";
              errorMsj2.innerHTML =
                '<span class="DCS-errorMsj"> Debe ser un código postal valido </span>';
              cpErrElement.parentNode.appendChild(errorMsj2);
            } else {
              errorMsj2.style.display = "none";
            }

            // [WCS-3276] check deshabilitado
            //checkError = !checkEl.checked;
            if (nombreEl != null && fechaEl != null) {
              nombreError = !nombreEl.value && window.site == "jubilacion";
              fechaError = !fechaEl.value && window.site == "jubilacion";
            }

            // añadir el mensaje de error del telefono
            if (phoneError) {
              errorMsj1.style.display = "";
              errorMsj1.innerHTML =
                '<span class="DCS-errorMsj"> Debe ser un telélefono válido. </span>';
              phoneEl.parentNode.appendChild(errorMsj1);
              if (window.location.href.indexOf("MAPGEN_OIMCOMUNI") > -1) {
                errorMsj1.innerHTML =
                  '<span class="DCS-errorMsj"> Debe ser un tel&#233fono v&#225lido. </span>';
                phoneEl.parentNode.appendChild(errorMsj1);
              }
            } else {
              errorMsj1.style.display = "none";
            }

            // añadir el mensaje de error del nombre
            if (nombreError) {
              errorMsj4.style.display = "";
              errorMsj4.innerHTML =
                '<span class="DCS-errorMsj"> Debe poner su nombre. </span>';
              nombreEl.parentNode.appendChild(errorMsj4);
            } else {
              errorMsj4.style.display = "none";
            }

            // añadir el mensaje de error del fecha
            if (fechaError) {
              errorMsj5.style.display = "";
              errorMsj5.innerHTML =
                '<span class="DCS-errorMsj"> Debe indicarnos su fecha de nacimiento </span>';
              fechaEl.parentNode.appendChild(errorMsj5);
            } else {
              errorMsj5.style.display = "none";
            }

            // [WCS-3276] check deshabilitado

            const doc = ActivadorBTN.findIndex(
              (elementActivador) =>
                elementActivador.nombre.toLowerCase() === "documento"
            );

            if (!phoneError && cpError == true && !nombreError && !fechaError) {
              let valueCpVerify = document.querySelector("#DCS-CP").value;
              DELIO.Mapfre.datalayerInfo.cp = valueCpVerify;
              window.userLabels.EDeclaratives.codigo_postal = valueCpVerify;
              // Implementacion de onetrustWS
              window.userLabels.EDeclaratives.onetrustWS =
                "ficha_producto_gratis";
              //Provincia
              DELIO.Mapfre.datalayerInfo.provincia =
                DELIO.Mapfre.newFuncionality.getProvincia(valueCpVerify);
              window.userLabels.EDeclaratives.provincia =
                DELIO.Mapfre.newFuncionality.getProvincia(valueCpVerify);
              // Vista de Gracias
              dmv.setContent(
                DelioTemplates.gracias({
                  msj: "En breve uno de nuestros agentes se pondr&aacute; en contacto contigo.",
                })
              );
              var btnClose = document.getElementsByClassName(
                "DCS-headerFormClose"
              )[0];
              btnClose.addEventListener("click", dmv.close);
              if (document.querySelector(".DCS-btnVolver button") != null) {
                document
                  .querySelector(".DCS-btnVolver button")
                  .addEventListener("click", dmv.close);
              }

              DELIO.Mapfre.newFuncionality.addLead();
            } else if (!phoneError && ActivadorBTN[doc].value == true) {
              let valueDocumentation =
                document.querySelector("#DCS-document").value;
              window.userLabels.EDeclaratives.document = valueDocumentation;
              //Implementacion de radio es cliente

              const isClienteRadio = () => {
                const radios = document.getElementsByName("esCliente");
                let opcionSeleccionada;
                for (const radio of radios) {
                  if (radio.checked) {
                    opcionSeleccionada = radio.value;
                    break;
                  }
                }
                return opcionSeleccionada;
              };

              window.userLabels.EDeclaratives.esCliente = isClienteRadio();

              // Implementacion de onetrustWS
              window.userLabels.EDeclaratives.onetrustWS =
                "ficha_producto_gratis";

              // Vista de Gracias
              dmv.setContent(
                DelioTemplates.gracias({
                  msj: "En breve uno de nuestros agentes se pondr&aacute; en contacto contigo.",
                })
              );
              var btnClose = document.getElementsByClassName(
                "DCS-headerFormClose"
              )[0];
              btnClose.addEventListener("click", dmv.close);
              if (document.querySelector(".DCS-btnVolver button") != null) {
                document
                  .querySelector(".DCS-btnVolver button")
                  .addEventListener("click", dmv.close);
              }

              DELIO.Mapfre.newFuncionality.addLead();
            }
          });
        }
      });

      dmv.on("close", function () {
        if (
          window.site == "ahorro" &&
          document.querySelector(".cdk-overlay-container")
        ) {
          document.querySelector(".cdk-overlay-container").innerHTML = "";
        }
      });
    }

    function ahorroFuncModal() {
      if (DELIO.initRingPool === false) {
        DELIO.initRingPool = true;
        loadRingPool(["#ringpool-top", ".drp-phone"]);
      }

      if (document.querySelector(".cdk-overlay-container")) {
        document.querySelector(".cdk-overlay-container").style.display = "none";
      }

      D3P.Modal.open();
    }

    function addListenerInputsNumber(element) {
      element.type = "tel";
      element.addEventListener("input", function (objEvt) {
        if (element.value.length == 1) {
          var cont = element.value;
          if (objEvt.data) {
            if (objEvt.data == "6" || objEvt.data == "7") {
            } else {
              element.value = cont.substr(0, cont.length - 1);
            }
          }
        } else {
          var cont = element.value;
          if (element.value.length <= 9) {
            if (objEvt.data) {
              if (objEvt.data.match("[0-9]")) {
              } else {
                element.value = cont.substr(0, cont.length - 1);
              }
            }
          } else {
            element.value = cont.substr(0, cont.length - 1);
          }
        }
      });
    }

    desActivarBTNSubmit();

    validacion(ActivadorBTN);
    HandleRingpool();

    addStylesModal();

    function oldHandleLeerMasMenos() {
      document.addEventListener("DOMContentLoaded", function () {
        // Ocultar los elementos con la clase 'complete-condiciones'
        var completeCondiciones = document.querySelectorAll(
          ".complete-condiciones"
        );
        completeCondiciones.forEach(function (element) {
          element.style.display = "none"; // Ocultar elementos
        });

        // Agregar evento de clic a los botones con la clase 'btnleermas-condiciones'
        var btnLeerMas = document.querySelectorAll(".btnleermas-condiciones");
        btnLeerMas.forEach(function (button) {
          button.addEventListener("click", function () {
            // Cambiar la visibilidad de los elementos 'complete-condiciones'
            completeCondiciones.forEach(function (element) {
              if (element.style.display === "none") {
                element.style.display = "block"; // Mostrar elementos
              } else {
                element.style.display = "none"; // Ocultar elementos
              }
            });

            // Cambiar el texto del botón dependiendo del texto actual
            if (this.textContent === "Leer menos...") {
              this.textContent = "Leer más...";
            } else {
              this.textContent = "Leer menos...";
            }
          });
        });
      });
    }

    //Validar codigo postal//
    function validarCodigoPostal(codigo) {
      try {
        var numeroPostal = codigo.value;
        var expresionRegular1 = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/; //<--- con esto vamos a validar el numero
        var expresionRegular2 = /\s/; //<--- con esto vamos a validar que no tenga espacios en blanco
        var provincias = [
          "ARABA/ALAVA",
          "Albacete",
          "Alicante",
          "Almeria",
          "Avila",
          "Badajoz",
          "Baleares",
          "Barcelona",
          "Burgos",
          "Caceres",
          "Cadiz",
          "Castellon",
          "Ciudad Real",
          "Cordoba",
          "Coruña",
          "Cuenca",
          "Gerona",
          "Granada",
          "Guadalajara",
          "Guipuzcoa",
          "Huelva",
          "Huesca",
          "Jaen",
          "Leon",
          "Lerida",
          "La Rioja",
          "Lugo",
          "Madrid",
          "Malaga",
          "Murcia",
          "Navarra",
          "Orense",
          "Asturias",
          "Palencia",
          "Las Palmas",
          "Pontevedra",
          "Salamanca",
          "Santa Cruz De Tenerife",
          "Cantabria",
          "Segovia",
          "Sevilla",
          "Soria",
          "Tarragona",
          "Teruel",
          "Toledo",
          "Valencia",
          "Valladolid",
          "BIZKAIA",
          "Zamora",
          "Zaragoza",
          "Ceuta",
          "Melilla",
        ];

        if (numeroPostal === "") {
          return false;
        } else if (expresionRegular2.test(numeroPostal)) {
          return false;
        } else if (!expresionRegular1.test(numeroPostal)) {
          return false;
        } else {
          var codigoProvincia = parseInt(numeroPostal.substring(0, 2)) - 1;
          if (codigoProvincia < 52) {
            var provinciasElements = document.querySelectorAll(
              "#Provincia, #Provincia1, #Provincia2"
            );

            if (!provinciasElements) return true;

            provinciasElements.forEach(function (element) {
              element.value = provincias[codigoProvincia];
            });
            return true;
          } else {
            var provinciasElements = document.querySelectorAll(
              "#Provincia, #Provincia1, #Provincia2"
            );

            if (!provinciasElements) return false;

            provinciasElements.forEach(function (element) {
              element.value = "Madrid";
            });
            return false;
          }
        }
      } catch (error) {
        var provinciasElements = document.querySelectorAll(
          "#Provincia, #Provincia1, #Provincia2"
        );

        if (!provinciasElements) return false;

        provinciasElements.forEach(function (element) {
          element.value = "Madrid";
        });
      }
    }

    /*
        |---------------------------------------------------------------------------
        | Obtener el template especificado.
        |---------------------------------------------------------------------------
        */
    function getDelioTemplates() {
      return {
        header_rp: function (data) {
          return (
            '<div class="DCS-RP">\
                    <div class="DCS-ClickToCall">\
                        <div class="DCS-imageClickToCall">\
                            <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/call-you-negative.jpg">\
                        </div>\
                        <a href="" id="ringpool-top" class="">' +
            data.msj +
            "</a>\
                    </div>\
                </div>"
          );
        },
        header: function (data) {
          return (
            '<div class="DCSS-c2c">\
                    <div class="DCS-ClickToCall">\
                        <div class="DCS-imageClickToCall">\
                            <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/call-you-negative.jpg">\
                        </div>\
                        <a href="" class="DCS-textClickToCall">' +
            data.msj +
            "</a>\
                    </div>\
                </div>"
          );
        },
        footer: function (data) {
          return (
            '<div class="DCSS-c2c">\
                    <div class="DCS-ClickToCall">\
                        <div class="DCS-imageClickToCall">\
                            <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/call-you-negative.jpg">\
                        </div>\
                        <a href="" class="DCS-textClickToCall" target="_blank">' +
            data.msj +
            "</a>\
                    </div>\
                </div>"
          );
        },
        modalRingPool: function (data) {
          const modalClientesTemplate =
            '<div class="DCS-Form DCS-Form-Coche DCS-Form-Clientes">\
                <div class="DCS-headerForm">\
                    <div class="titulo">' +
            data.title +
            '</div>\
                    <div class="DCS-headerFormClose"> <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/cross.png" alt=""> </div>\
                </div>\
                <hr class="hr_style"></hr>\
                <div class="seguro_container">\
                    <p class="text_seguro_container">\
                        ¿Eres Cliente de MAPFRE?\
                    </p>\
                    <div class="box_btn_container">\
                        <div>\
                            <input type="radio" id="si" class="wg-input" name="esCliente" value="si" data-wg-validation="required" required />\
                            <label class="btn_seguro" for="si"\
                            style="display: inherit; width: 5rem !important; height: 2rem !important;"\
                            >SI</label>\
                        </div>\
                        <div>\
                            <input type="radio" id="no" class="wg-input"  name="esCliente" value="no" data-wg-validation="required" />\
                            <label class="btn_seguro" for="no"\
                            style="display: inherit; width: 5rem !important; height: 2rem !important;"\
                            >NO</label>\
                        </div>\
                    </div>\
                </div>\
                <hr class="hr_style"></hr>\
                <div class="container_element">\
                    <div class="container_msn_dni gestion_documento">\
                        <div class="container_icon">\
                            <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/hucha.png" alt="imagen de cerdito">\
                        </div>\
                        <div class="container_text">\
                            <p class="text_pregunta"><strong>¿Por qué es tan importante tu DNI/NIE?</b></p>\
                            <p class="text_respuesta">Así podremos ofrecerte el mejor precio.</p>\
                        </div>\
                    </div>\
                    <div class="form-group gestion_documento" style="display: grid;">\
                        <label class="text_input_label" for="DCS-document">DNI/NIE</label>\
                        <input type="text" class="form-control" id="DCS-document" maxlength="9" name="Documento"\
                            placeholder="12345678A*/X1234567A" />\
                        <p class="error_form_global error__documento"></p>\
                    </div>\
                    <input type="hidden" name="wm__control" value="checked" class="wg-input" />\
                    <input type="hidden" id="variable_campaña" name="campaña" class="wg-input" value=""/>\
                    <input type="hidden" id="origen" name="c_var_26" class="wg-cvar"\
                    <input type="hidden" id="tipoContacto" name="c_var_12" class="wg-cvar" value="Estándar"\
                    <input type="hidden" name="publicidad_perfilada_aceptada" class="wg-input hd_publicidad_aceptada" value="no" >\
                    <div class="form-group" style="display: grid;">\
                        <label class="text_input_label" for="DCS-phone">TELÉFONO MÓVIL</label>\
                        <input type="tel" class="form-control" id="DCS-phone" maxlength="9" name="Telefono" />\
                        <p class="error_form_global error__telefono"></p>\
                    </div>\
                    <div class="form-group gestion_cp container_element" style="display: none;">\
                        <label class="text_input_label" for="DCS-CP">CÓDIGO POSTAL</label>\
                        <input type="tel" class="form-control" id="DCS-CP" maxlength="5" name="Codigo_postal" />\
                        <p class="error_form_global error__codigo_postal"></p>\
                    </div>\
                    <div class="form-group container_element">\
                        <div class="container_condiciones">\
                            <p class="condiciones_pequeña">\
                              MAPFRE ESPAÑA S.A.como responsable del tratamiento, utilizará sus datos personales para atender su\
                              petición a través de los canales que nos ha facilitado. <strong id="boton"\
                            class="btn-condiciones leer_mas" > Leer más</strong >\
                          </p>\
                          <p class="condiciones_grande">\
                            MAPFRE ESPAÑA S.A. como responsable del tratamiento, utilizará sus datos personales para atender su\
                            petición a través de los canales que nos ha facilitado. Al pulsar el botón "Te llamamos gratis",\
                            reconoce haber leído y comprendido la <a\
                              href="https://www.mapfre.es/seguros/privacidad/privacidad.jsp" target="_blank">política de\
                              privacidad</a>, así como los términos relativos a cómo ejercer sus derechos de acceso,\
                            rectificación, oposición, supresión, limitación y portabilidad de sus datos. <strong id="boton"\
                              class="btn-condiciones leer_menos">Leer menos</strong>\
                          </p>\
                        </div>\
                        <div class="form-group cboxPublicidad2" style="gap: 7px;">\
                            <input type="checkbox" id="publicidad_perfilada_aceptada" class="cbox_publicidad_aceptada">\
                            <label class="publicidad_pequeña" >\
                              Quiero recibir comunicaciones comerciales personalizadas de MAPFRE ESPAÑA, COMPAÑÍA DE SEGUROS Y\
                                  REASEGUROS S.A.por cualquier medio. <strong id="boton"\
                              class="btn-condiciones leer_mas_publicidad" > Leer\
                                    más</strong >\
                            </label >\
                              <label class="publicidad_grande">\
                                Quiero recibir comunicaciones comerciales personalizadas de MAPFRE ESPAÑA, COMPAÑÍA DE SEGUROS Y\
                                REASEGUROS S.A. por cualquier medio, incluido el correo electrónico, sobre productos, servicios y\
                                ofertas para lo que consiento que se elabore un perfil sobre mí de acuerdo con lo detallado en la\
                                <a href="https://www.mapfre.es/seguros/privacidad/privacidad.jsp" target="_blank">política de\
                                  privacidad</a>. <strong id="boton" class="btn-condiciones leer_menos_publicidad">Leer menos</strong>\
                            </label>\
                        </div>\
                        <div class="form-group botonera-sup">\
                            <button type="button" class="DCS-footerFormButton btn wg-submit btn_activo" disabled>\
                                TE LLAMAMOS GRATIS\
                            </button>\
                            <button class="btn boton-verde btn_in_activo" style="width: 100%;">\
                                TE LLAMAMOS GRATIS\
                            </button>\
                        </div>\
                        <div id="business_hours_container">\
                            <hr class="hr_style">\
                            <div class="botonera">\
                                <div class="Subtitulo inferior">O si lo prefieres llámanos al:</div>\
                                <a class="llamanos-btn wm_rp_local_esp_link drp-phone html-drp-phone wal-drp-phone wal-drp-phone"\
                                    id="cmbRP" href="tel:911985503">911 985 503</a>\
                            </div>\
                            <div class="date_conteiner">\
                                <img class="date_img" src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/icon-time.png" />\
                                <p class="date_text">L - V 9:00 - 22:00h</p>\
                            </div>\
                        </div>\
                    </div>\
                </div>';

          oldHandleLeerMasMenos();

          var divContainer = document.getElementById("dmv-content");
          divContainer.classList.add("dmv-content-coche");
          return modalClientesTemplate;
        },
        modalSinRingPool: function (data) {
          const modalClientesTemplate =
            '<div class="DCS-Form DCS-Form-Coche DCS-Form-Clientes">\
                <div class="DCS-headerForm">\
                    <div class="titulo">' +
            data.title +
            '</div>\
                    <div class="DCS-headerFormClose"> <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/cross.png" alt=""> </div>\
                </div>\
                <hr class="hr_style"></hr>\
                <div class="seguro_container">\
                    <p class="text_seguro_container">\
                        ¿Eres Cliente de MAPFRE?\
                    </p>\
                    <div class="box_btn_container">\
                        <div>\
                            <input type="radio" id="si" class="wg-input" name="esCliente" value="si" data-wg-validation="required" required />\
                            <label class="btn_seguro" for="si"\
                            style="display: inherit; width: 5rem !important; height: 2rem !important;"\
                            >SI</label>\
                        </div>\
                        <div>\
                            <input type="radio" id="no" class="wg-input"  name="esCliente" value="no" data-wg-validation="required" />\
                            <label class="btn_seguro" for="no"\
                            style="display: inherit; width: 5rem !important; height: 2rem !important;"\
                            >NO</label>\
                        </div>\
                    </div>\
                </div>\
                <hr class="hr_style"></hr>\
                <div class="container_element">\
                    <div class="container_msn_dni gestion_documento">\
                        <div class="container_icon">\
                            <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/hucha.png" alt="imagen de cerdito">\
                        </div>\
                        <div class="container_text">\
                            <p class="text_pregunta"><strong>¿Por qué es tan importante tu DNI/NIE?</b></p>\
                            <p class="text_respuesta">Así podremos ofrecerte el mejor precio.</p>\
                        </div>\
                    </div>\
                    <div class="form-group gestion_documento" style="display: grid;">\
                        <label class="text_input_label" for="DCS-document">DNI/NIE</label>\
                        <input type="text" class="form-control" id="DCS-document" maxlength="9" name="Documento"\
                            placeholder="12345678A*/X1234567A" />\
                        <p class="error_form_global error__documento"></p>\
                    </div>\
                    <input type="hidden" name="wm__control" value="checked" class="wg-input" />\
                    <input type="hidden" id="variable_campaña" name="campaña" class="wg-input" value=""/>\
                    <input type="hidden" id="origen" name="c_var_26" class="wg-cvar"\
                    <input type="hidden" id="tipoContacto" name="c_var_12" class="wg-cvar" value="Estándar"\
                    <input type="hidden" name="publicidad_perfilada_aceptada" class="wg-input hd_publicidad_aceptada" value = "no" >\
                    <div class="form-group" style="display: grid;">\
                        <label class="text_input_label" for="DCS-phone">TELÉFONO MÓVIL</label>\
                        <input type="tel" class="form-control" id="DCS-phone" maxlength="9" name="Telefono" />\
                        <p class="error_form_global error__telefono"></p>\
                    </div>\
                    <div class="form-group gestion_cp container_element" style="display: none;">\
                        <label class="text_input_label" for="DCS-CP">CÓDIGO POSTAL</label>\
                        <input type="tel" class="form-control" id="DCS-CP" maxlength="5" name="Codigo_postal" />\
                        <p class="error_form_global error__codigo_postal"></p>\
                    </div>\
                    <div class="form-group container_element">\
                        <div class="container_condiciones">\
                          <p class="condiciones_pequeña">\
                              MAPFRE ESPAÑA S.A.como responsable del tratamiento, utilizará sus datos personales para atender su\
                              petición a través de los canales que nos ha facilitado. <strong id="boton"\
                            class="btn-condiciones leer_mas" > Leer más</strong >\
                          </p >\
                          <p class="condiciones_grande">\
                            MAPFRE ESPAÑA S.A. como responsable del tratamiento, utilizará sus datos personales para atender su\
                            petición a través de los canales que nos ha facilitado. Al pulsar el botón "Te llamamos gratis",\
                            reconoce haber leído y comprendido la <a\
                              href="https://www.mapfre.es/seguros/privacidad/privacidad.jsp" target="_blank">política de\
                              privacidad</a>, así como los términos relativos a cómo ejercer sus derechos de acceso,\
                            rectificación, oposición, supresión, limitación y portabilidad de sus datos. <strong id="boton"\
                              class="btn-condiciones leer_menos">Leer menos</strong>\
                          </p>\
                        </div>\
                        <div class="form-group cboxPublicidad2" style="gap: 7px;">\
                            <input type="checkbox" id="publicidad_perfilada_aceptada" class="cbox_publicidad_aceptada">\
                            <label class="publicidad_pequeña" >\
                              Quiero recibir comunicaciones comerciales personalizadas de MAPFRE ESPAÑA, COMPAÑÍA DE SEGUROS Y\
                                  REASEGUROS S.A.por cualquier medio. <strong id="boton"\
                              class="btn-condiciones leer_mas_publicidad"> Leer\
                                    más</strong >\
                                </label >\
                                  <label class="publicidad_grande">\
                                    Quiero recibir comunicaciones comerciales personalizadas de MAPFRE ESPAÑA, COMPAÑÍA DE SEGUROS Y\
                                      REASEGUROS S.A. por cualquier medio, incluido el correo electrónico, sobre productos, servicios y\
                                      ofertas para lo que consiento que se elabore un perfil sobre mí de acuerdo con lo detallado en la\
                                      <a href="https://www.mapfre.es/seguros/privacidad/privacidad.jsp" target="_blank">política de\
                                      privacidad</a>. <strong id="boton" class="btn-condiciones leer_menos_publicidad">Leer menos</strong>\
                            </label>\
                        </div>\
                        <div class="form-group botonera-sup">\
                            <button type="button" class="DCS-footerFormButton btn wg-submit btn_activo" disabled>\
                                TE LLAMAMOS GRATIS\
                            </button>\
                            <button class="btn boton-verde btn_in_activo" style="width: 100%;">\
                                TE LLAMAMOS GRATIS\
                            </button>\
                        </div>\
                        <div id="business_hours_container">\
                            <hr class="hr_style">\
                            <div class="botonera">\
                                <div class="Subtitulo inferior">O si lo prefieres llámanos al:</div>\
                                <a class="llamanos-btn wm_rp_local_esp_link drp-phone html-drp-phone wal-drp-phone wal-drp-phone"\
                                    id="cmbRP" href="tel:911985503">911 985 503</a>\
                            </div>\
                            <div class="date_conteiner">\
                                <img class="date_img" src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/icon-time.png" />\
                                <p class="date_text">L - V 9:00 - 22:00h</p>\
                            </div>\
                        </div>\
                    </div>\
                </div>';

          oldHandleLeerMasMenos();
          var divContainer = document.getElementById("dmv-content");
          divContainer.classList.add("dmv-content-coche");
          return modalClientesTemplate;
        },
        gracias: function (data) {
          const modalGraciasClientes =
            '<div class="DCS-Form DCS-Form-Gracias">\
                <div class="DCS-headerForm">\
                    <div class="DCS-headerFormTitle"><svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">\
                    <circle cx="48" cy="48" r="46.5" stroke="#008C47" stroke-width="3"/>\
                    <path d="M65.4 35.8002C64.6 35.0002 63.4 35.0002 62.6 35.8002L42.6 55.8002L33.4 46.6002C32.6 45.8002 31.4 45.8002 30.6 46.6002C29.8 47.4002 29.8 48.6002 30.6 49.4002L41.2 60.2002C41.6 60.6002 42 60.8002 42.6 60.8002C43.2 60.8002 43.6 60.6002 44 60.2002L65.4 38.6002C66.2 37.8002 66.2 36.6002 65.4 35.8002Z" fill="#008C47"/>\
                    </svg></div>\
                    <div class="DCS-headerFormClose"> <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/cross.png" alt=""> </div>\
                </div>\
                <div class="DCS-bodyForm">\
                    <h2 class="DCS-Body-H2">Gracias por tu interés</h2>\
                    <div class="DCS-bodyFormMessage">' +
            data.msj +
            '</div>\
                </div>\
                <div class="DCS-btnVolver">\
                    <button type="button">Volver</button>\
                <div>\
                </div>';
          return modalGraciasClientes;
        },
      };
    }

    /*
        |---------------------------------------------------------------------------
        | Iniciar servicio RingPool
        |---------------------------------------------------------------------------
        */
    function loadRingPool(capa) {
      let urlData = new URL(window.location.href);
      let origen_data = urlData.searchParams.get("origen");

      if (
        origen_data != null &&
        origen_data != undefined &&
        origen_data != "undefined"
      ) {
        window.c_var_26 = origen_data;
      }

      const intervalOrigen = setInterval(() => {
        let elementFromOrigen = document.getElementsByName("c_var_26");
        if (
          origen_data != null &&
          origen_data != undefined &&
          origen_data != "undefined" &&
          elementFromOrigen
        ) {
          clearInterval(intervalOrigen);
          elementFromOrigen.forEach((input) => {
            input.value = origen_data;
          });
        }
      }, 500);

      // const intervalProducto = setInterval(()=>{
      //     if(window.c_var_4 !== ""){
      //         clearInterval(intervalProducto)
      //         window.userLabels.EConversion.push({id:4,value:window.c_var_4})
      //         // DRP.loadConversions(userLabels);
      //     }
      // },300);

      //cambiar el campaign id. (servicio de prueba = MAPFRE_RP_AUTO_916025307)
      window.DRP_ready = function () {
        var service = DELIO.Mapfre.newFuncionality.getRPService();
        if (window.location.href.indexOf("accion=vrt") > -1) {
          userLabels.EDeclaratives.Campanialead = "Acción Verti";
        }
        var ori = DELIO.Mapfre.getQueryVariable("origen");
        var origen = ori === "MOVISTA" || ori === "MOVISTA/";
        var tari =
          window.site === "coche" ||
          window.site === "moto" ||
          window.site === "autos";
        var utmSource = getUrlVariable()["utm_source"];
        var origenUrl = getUrlVariable()["origen"];

        if (origen && tari) {
          service = "4600AB2D2B406AF9720F3D3E1E356008";
        } else if (utmSource) {
          if (utmSource === "acierto" || utmSource === "arpem") {
            service = "D29B79219A6B8589030F204519082309";
          }
        }

        if (origenUrl === "COCHECO" && window.site === "coche") {
          service = "4B2B4805215CB648961004042C503902";
        }

        var posibleNewService = getRingPoolService();
        if (posibleNewService) {
          service = posibleNewService;
        }

        if (window.site == "bici") {
          service = "D7E8CE9B7E6DF433660F203426570A04";
        }
        if (window.site == "dental") {
          service = "12902C0AEC567CBA24100B410A341800";
        }
        if (window.site == "accidentes") {
          service = "9D8AAB06A730AEADCD100B410B310204";
        }
        if (window.site == "lex") {
          service = "9065C56A83980F1886100B410B565E06";
        }
        if (window.site == "decesos") {
          service = "D9400148CA8A36F34C0F12343C1C5703";
        }
        if (window.site == "comunidades") {
          service = "C3749F1DACF0B3C40010255411345F04";
        }
        if (window.site == "mascotas") {
          service = "528D825D382029C2740F1E4E37381C09";
        }

        if (window.site == "hogar") {
          if (typeof userLabelsDRP != "undefined" && typeof userLabelsDRP.EDeclaratives != "undefined") {
            userLabels.EDeclaratives.Scoring_IVR = userLabelsDRP.EDeclaratives.Scoring_IVR;
            userLabels.EDeclaratives.Scoring_priority = userLabelsDRP.EDeclaratives.Scoring_priority;
          }

          if (typeof userLabelsDRP != "undefined" && typeof userLabelsDRP.EExternals != "undefined" &&
            typeof userLabels != "undefined" && typeof userLabels.EExternals != "undefined") {
            userLabels.EExternals.forEach(function (e) {
              if (e.id == 1263) {
                e = userLabelsDRP.EExternals[0];
              } else if (e.id == 1264) {
                e = userLabelsDRP.EExternals[1];
              }
            });
          }
        }

        var defaultPhoneBySite =
          DELIO.Mapfre.newFuncionality.getRPDefaultPhone();
        DRP.init({
          capa: capa,
          labels: window.userLabels,
          campaignid: service,
          defaultPhone: defaultPhoneBySite,
          maskPhone: "00 000 00 00",
          called: function (response) {

            console("reponse ringpool", response);
            if (window.Piwik) idlead = Piwik.getAsyncTracker().getVisitorId();

            //seteo las conversion online
            try {
              if (s.products.indexOf("moto") != -1) {
                /* window.c_var_4 = "Moto"; */
              } else if (s.products.indexOf("Coche") != -1) {
                /* window.c_var_4 = "Coche"; */
              } else {
                /* window.c_var_4 = DELIO.Mapfre.getProduct(); */
                if (DELIO.Mapfre.getProduct() == "Ahorro") {
                  /* window.c_var_4 = 'vida'; */
                }
              }
            } catch (error) { }

            var url =
              "https://t.womtp.com/js/otg.min.js?idtag=" +
              DELIO.Mapfre.global.idTagConversion +
              "&orderid=" +
              idlead;
            //cargo la conversion
            DAL.Ajax({ type: "script", url: url });
          },
          idTag: DELIO.Mapfre.global.idTagDelioClient,
          reqPhone: function (data) {
            window.telefono = data.telefono;
            if (window.site === "coche") {
              var dataDec;
              var date = new Date();
              var day = date.getDay();
              var hour = date.getHours();
              if (day >= 1 && day <= 5 && hour >= 11 && hour <= 19) {
                dataDec = "Si";
              } else {
                dataDec = "No";
              }

              labels = userLabels;
              labels.EDeclaratives.En_Horario_chat = dataDec;
              labels.EDeclaratives.url_conversion_completa =
                window.location.href;

              if (typeof digitalData != "undefined") {
                // Risk Score
                if (typeof digitalData.ScoreC != "undefined") {
                  labels.EDeclaratives.risk_score = digitalData.ScoreC;
                }
                //pAprox
                if (typeof digitalData.pAprox != "undefined") {
                  labels.EDeclaratives.pAprox = digitalData.pAprox;
                }
                //Diferencia
                if (typeof digitalData.diferencia != "undefined") {
                  labels.EDeclaratives.Diferencia = digitalData.diferencia;
                }
                //Usuario
                if (typeof digitalData.usuario != "undefined") {
                  labels.EDeclaratives.Usuario = digitalData.usuario;
                }
              }
              DRP.loadLabels(labels);
            }

            let isBot = "No";
            if (window.location.href.indexOf("origen=R") > -1) {
              isBot = "Si";
            }

            labels = userLabels;
            labels.EDeclaratives.bot_detectado = isBot;
            labels.EDeclaratives.url_conversion_completa = window.location.href;
            labels.EDeclaratives.Lead_Entorno_PRE = "No";

            if (window.location.href.indexOf("wmapfre.pre.") > -1) {
              labels.EDeclaratives.Lead_Entorno_PRE = "Si";
            }
            if (window.location.href.indexOf("final.preeurasiabk") > -1) {
              labels.EDeclaratives.Lead_Entorno_PRE = "Si";
            }

            if (window.location.href.indexOf("accion=vrt") > -1) {
              labels.EDeclaratives.Campanialead = "Acción Verti";
            }

            DRP.loadLabels(labels);
            // if (window.site === "coche" || window.site === "moto" || window.site === "autos") {
            //     var clientVal = "NO";
            //     if (DELIO.isClientMapfre) {
            //         clientVal = "SI";
            //     }
            //     labels = {"EDeclaratives": {
            //         "cliente": clientVal,
            //     }};
            //     DRP.loadLabels(labels);
            // }
          },
        });
      };
      if (DELIO.drpCharge === false) {
        DELIO.drpCharge = true;
        DAL.Ajax({ type: "jsonp", url: DELIO.Mapfre.global.ringPool });
      } else if (DELIO.drpCharge === true) {
        window.DRP_ready();
      }
    }

    function getUrlVariable() {
      var vars = [],
        hash;
      var hashes = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }

    /*
        |---------------------------------------------------------------------------
        | CARGA DE DELIO1CLICK PARA CHAT
        |---------------------------------------------------------------------------
        */
    function addDelio1click() {
      window.idTagDelio =
        "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953abe4cb254380fee21da1e87e8c82a173c2256c0940ada1f402a8e36cb8005bad3d78ba02847c3a2ee290b7a9230f26225d95661ba59166fafef871b03c6e8ac90db0ab8a79aaef07d8e4cc697ee165fae";
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://t.womtp.com/slider/c/delio-lm/dfi/init.js";
      var head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    }

    /*
        |---------------------------------------------------------------------------
        | CARGA DE DELIO1CLICK PARA CHAT
        |---------------------------------------------------------------------------
        */
    function addChatParams() {
      window.SIO_chatEvents = {
        addSecondMessage: {
          message:
            "Antes de nada, informarte que para garantizar tu seguridad, no debes escribir datos personales dentro del chat.",
        },
        IVR_config: {
          questions: ["¿Está interesado en un nuevo presupuesto?"],
          options: [["SI", "NO"]],
          events: [["start", "end"]],
          labeldata: [["si presupuesto", "no presupuesto"]],
          startMessage: "",
          endMessage:
            "Muchas gracias por su tiempo. Para cualquier consulta póngase en contacto con 918 366 240.",
        },
        privacyPolicyUrl:
          "https://segurosdecoche.mapfre.es/privacidad/privac_ROPO.html",
        onStartCobrowsing: function () {
          //Función añadida para enviar inicio de cobrowsing a analíticas
          if (typeof tagManager !== "undefined") {
            tagManager.utils.walmericChatInteraction("startCobrowsing");
          }
        },
        onDSAClick: function () {
          visitSetVisitVars(
            "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
            [
              { id: "16", value: "SI" },
              { id: "15", value: "SI" },
            ],
            womtp.idTag,
            window.Walmeric_leadid
          );
        },
        onStartIVR: function () {
          DELIO.setConVar16 = true;
          visitSetVisitVars(
            "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
            [
              { id: "17", value: "SI" },
              { id: "15", value: "SI" },
              { id: "16", value: "SI" },
            ],
            womtp.idTag,
            window.Walmeric_leadid
          );
        },
        onEndIVR: function () {
          visitSetVisitVars(
            "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
            [{ id: "17", value: "NO_INTERESADO" }],
            womtp.idTag,
            window.Walmeric_leadid
          );
        },
        onOverflow: function () {
          visitSetVisitVars(
            "https://ws.walmeric.com/provision/visitsLabel/updateVisitLabelByVisitorId.html",
            [{ id: "17", value: "NO_DISPO" }],
            womtp.idTag,
            window.Walmeric_leadid
          );
        },
        onEndInitialization: function () {
          if (window.SIO && SIO.Chat) {
            SIO.Chat.runIVR();
          }
        },
        onSendMessage: function () {
          trackChat();
          DELIO.openChat = true;
        },
        onRoomCreated: function () {
          //ha seteado el idelead del chat para setear la actulización
          try {
            var clientVal = "NO";
            if (DELIO.isClientMapfre) {
              clientVal = "SI";
            }
            localStorage.setItem(
              "leadChat",
              SIO.Chat.global.leadId || SIO.Chat.storage().wm_user
            );
            updateChat({
              EDeclaratives: { cliente: clientVal },
              EConversions: [
                {
                  id: "18",
                  value: window.nombre_pagina.substr(
                    window.nombre_pagina.indexOf("_") + 1
                  ),
                },
              ],
            });
          } catch (error) {
            updateChat({
              EConversions: [{ id: "18", value: "noEspecificado" }],
            });
            console.log(error); //si no nos han seteado el nombre de la página
          }
          if (DELIO.Mapfre.newFuncionality.getStep() == 2) {
            var codPresupuesto = "";
            if (
              typeof window.cod_presupuesto != "undefined" &&
              window.cod_presupuesto != "" &&
              window.cod_presupuesto != "undefined"
            ) {
              codPresupuesto = window.cod_presupuesto;
            } else {
              try {
                if (~window.location.href.indexOf("calcular-seguros-coche")) {
                  codPresupuesto = digitalData.quotation_id;
                  if (typeof codPresupuesto == "undefined") {
                    codPresupuesto = "";
                  }
                } else {
                  codPresupuesto = JSON.parse(localStorage.getItem("autosData"))
                    .dataModel.numPresupuestoRUP;
                  if (typeof codPresupuesto == "undefined") {
                    codPresupuesto = "";
                  }
                }
              } catch (error) {
                codPresupuesto = "";
              }
            }
            updateChat({ EDeclaratives: { cod_presupuesto: codPresupuesto } });
          }
          DELIO.openChat = true;
        },
      };
    }

    function visitSetVisitVars(wsVisitVars, v_vars_obj, idTag, leadid) {
      DAL.Ajax({
        type: "jsonp",
        url: wsVisitVars,
        data: {
          data: encodeURIComponent(JSON.stringify(v_vars_obj)),
          idTag: idTag,
          idVisitor: leadid,
          format: "jsonp",
        },
      }).done(function (dataResp) {
        //console.log("set visit default visit vars");
      });
    }

    function getUrlParams() {
      var url = document.location.href;

      if (url.indexOf("?") > 0) {
        var getString = url.split("?")[1];

        var GET = getString.split("&");
        var get = {};

        for (var i = 0, l = GET.length; i < l; i++) {
          var tmp = GET[i].split("=");
          get[tmp[0]] = unescape(decodeURI(tmp[1]));
        }
        return get;
      } else {
        return false;
      }
    }

    /* function addConVar16btn () {
            try {
                var infoSio = SIO.Chat.storage();
     
                if (typeof infoSio.wm_chat_show != "undefined" && infoSio.wm_chat_show.value != false) {
                    womtp.c_vars[16] = "Si";
                } else if (DELIO.abreChat == true) {
                    womtp.c_vars[16] = "Si";
                } else {
                    womtp.c_vars[16] = "No";
                }
     
            } catch (error) {}
        } */
  })(function () {
    function getUrlParams() {
      var url = document.location.href;

      if (url.indexOf("?") > 0) {
        var getString = url.split("?")[1];

        var GET = getString.split("&");
        var get = {};

        for (var i = 0, l = GET.length; i < l; i++) {
          var tmp = GET[i].split("=");
          get[tmp[0]] = unescape(decodeURI(tmp[1]));
        }
        return get;
      } else {
        return false;
      }
    }

    function changeOrigenVida(siteSelected) {
      const urlLocal = new URL(window.location.href);
      let result = "";

      if (
        siteSelected.toLocaleLowerCase() == "vida" ||
        siteSelected.toLocaleLowerCase() == "vidas"
      ) {
        result = "Confianza_vida";
      } else if (urlLocal.pathname === "/particulares/") {
        result = "coche";
      } else {
        result = siteSelected;
      }

      return result;
    }

    if (getUrlParams()["utm_campaign"]) {
      let urlData = new URL(window.location.href);
      let valorCampaing = urlData.searchParams.get("utm_campaign");

      const timer = setInterval(() => {
        let elementFromCampaing = document.getElementsByName("campaña");

        if (
          valorCampaing != null &&
          valorCampaing != undefined &&
          valorCampaing != "undefined" &&
          window.userLabels.EDeclaratives != undefined &&
          window.userLabels.EDeclaratives != "undefined" &&
          elementFromCampaing.length
        ) {
          clearInterval(timer);
          window.userLabels.EDeclaratives.campaña = valorCampaing;

          globalThis.v_var_8 = valorCampaing;

          for (let index = 0; index < elementFromCampaing.length; ++index) {
            elementFromCampaing[index].value = valorCampaing;
          }
        }
      }, 500);
    }

    DELIO.Mapfre.step = {
      coche: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      moto: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      autos: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      salud: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      hogar: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      vida: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      jubilacion: {
        1: "Paso1",
        2: "Paso2_Precio",
        3: "Paso3_InicioContratacion",
      },
      bicicleta: {
        1: "Paso1",
        2: "Paso2_Precio",
        3: "Paso3_InicioContratacion",
      },
      accidentes: {
        1: "Paso1",
        2: "Paso2_Precio",
        3: "Paso3_InicioContratacion",
      },
      viajes: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      mascotas: {
        1: "Paso1",
        2: "Paso2_Precio",
        3: "Paso3_InicioContratacion",
      },
      bici: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      dental: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      lex: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      comunidades: {
        1: "Paso1",
        2: "Paso2_Precio",
        3: "Paso3_InicioContratacion",
      },
      decesos: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
      ahorro: { 1: "Paso1", 2: "Paso2_Precio", 3: "Paso3_InicioContratacion" },
    };

    DELIO.Mapfre.newFuncionality = {
      addLead: function () {
        //determino si se cogera la info de rm
        var bRM = this.getIsRM();
        //recojo toda la info de este lead
        var dataLead = this.getLeadLabels({}, bRM);

        var duplicateWindow = "&deduplicateWindow=15d&deduplicateLabel=phone";
        if (DELIO.Mapfre.getQueryVariable("walmeticDeduplicate") == "false") {
          duplicateWindow = "";
        }

        dataLead.Lead_Entorno_PRE = "No";

        let isBot = "No";
        if (window.location.href.indexOf("origen=R") > -1) {
          isBot = "Si";
        }

        dataLead.bot_detectado = isBot;

        if (window.location.href.indexOf("wmapfre.pre.") > -1) {
          dataLead.Lead_Entorno_PRE = "Si";
        }
        if (window.location.href.indexOf("final.preeurasiabk") > -1) {
          dataLead.Lead_Entorno_PRE = "Si";
        }

        var urlConversion = encodeURIComponent(window.location.href).replace(
          /%20/g,
          "+"
        );

        //seteo las conversion online

        try {
          if (s.products.indexOf("moto") != -1) {
            /*      window.c_var_4 = "Moto"; */
          } else if (s.products.indexOf("Coche") != -1) {
            /*  window.c_var_4 = "Coche"; */
          } else {
            window.c_var_4 = changeOrigenVida(DELIO.Mapfre.getProduct());
            /* if (DELIO.Mapfre.getProduct() == 'Ahorro') {
                            window.c_var_4 = 'vida';
                        } */
          }
        } catch (error) { }

        // Conversiones offline
        if (DELIO.Mapfre.getQueryVariable("res")) {
          if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn") {
            womtp.c_vars[11] = "Si_Rec_Presu_Burn";

            var conversionsValues = [
              //site
              {
                /* id: "4", value: window.c_var_4  */
              },

              //step
              /* { id: "5", value: window.c_var_5 }, */
              { id: "11", value: "Si_Rec_Presu_Burn" },
            ];
          } else if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn_b") {
            womtp.c_vars[11] = "Si_Rec_Presu_Burn";
            womtp.c_vars[9] = "Banner";

            var conversionsValues = [
              //site
              {
                /* id: "4", value: window.c_var_4 */
              },

              //step
              /* { id: "5", value: window.c_var_5 }, */
              { id: "9", value: "Banner" },
              { id: "11", value: "Si_Rec_Presu_Burn" },
            ];
          } else if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn_h") {
            womtp.c_vars[11] = "Si_Rec_Presu_Burn";
            womtp.c_vars[9] = "Home";

            var conversionsValues = [
              //site
              {
                /* id: "4", value: window.c_var_4 */
              },

              //step
              /* { id: "5", value: window.c_var_5 }, */
              { id: "9", value: "Home" },
              { id: "11", value: "Si_Rec_Presu_Burn" },
            ];
          } else {
            womtp.c_vars[11] = "si";

            var conversionsValues = [
              //site
              /* {  id: "4", value: window.c_var_4 }, */

              //step
              /*  { id: "5", value: window.c_var_5 }, */
              { id: "11", value: "si" },
            ];
          }
        } else {
          var conversionsValues = [];
        }

        if (DELIO.cvnegocio) {
          conversionsValues.forEach((conversion) => {
            if (conversion.id === "4") {
              conversion.value = "mascotas";
              womtp.c_vars[4] = "mascotas";
            } else if (conversion.id === "3") {
              conversion.value = "formulario";
              womtp.c_vars[3] = "formulario";
              window.c_var_3 = "formulario";
            } else if (conversion.id === "8") {
              conversion.value = "mascotas";
              womtp.c_vars[8] = "mascotas";
            } else if (conversion.id === "5") {
              conversion.value = "Paso2_Precio";
              womtp.c_vars[5] = "Paso2_Precio";
            }
          });

          conversionsValues.push({ id: "5", value: "Paso2_Precio" });
          womtp.c_vars[5] = "Paso2_Precio";

          conversionsValues.push({ id: "3", value: "formulario" });
          womtp.c_vars[3] = "formulario";
          window.c_var_3 = "formulario";

          if (window.site === "hogar" && DELIO.cvnegocio) {
            dataLead.anio_construccion = "";
            dataLead.capital_de_contenido = "";
            dataLead.capital_de_continente = "";
            dataLead.Edificio = "";
            dataLead.precio0 = "";
            dataLead.precio1 = "";
            dataLead.precio2 = "";
            dataLead.metros_construidos = "";
            dataLead.Cod_Ref_Hogar_Familia = "";
            dataLead.Cod_Ref_Hogar_Platino = "";
            dataLead.Cod_Ref_Hogar_Tu_Eliges = "";
            dataLead.regimen = "";
            dataLead.sistemas_no_electronicos_de_seguridad = "";
            dataLead.uso = "";
            dataLead.proteccion_domotica = "";
            dataLead.sistemasElectronicos = "";
            dataLead.numero_banio = "";
            dataLead.numero_habitaciones = "";
            dataLead.construccion = "";
            dataLead.hipoteca = "";
          }

          DELIO.cvnegocio = false;
        }

        //Analitica conversiones clientes Mapfre

        if (window.location.href.includes("particulares")) {
          conversionsValues.push({ id: "3", value: window.c_var_3 });
          womtp.c_vars[3] = window.c_var_3;

          //Este producto se setea en la función/archivo handleProductByUrl.js
          if (window.location.href.includes("patinete-electrico")) {
            conversionsValues.push({ id: "4", value: "Patinete" });
            womtp.c_vars[4] = "Patinete";
            window.c_var_4 = "Patinete";
          } else {
            conversionsValues.push({ id: "4", value: window.c_var_4 });
            womtp.c_vars[4] = window.c_var_4;
            window.c_var_4 = window.c_var_4;
          }

          if (window.location.href.includes("seguros-dentales")) {
            conversionsValues.push({ id: "4", value: "Dental" });
            womtp.c_vars[4] = "Dental";
            window.c_var_4 = "Dental";
          } else {
            conversionsValues.push({ id: "4", value: window.c_var_4 });
            womtp.c_vars[4] = window.c_var_4;
            window.c_var_4 = window.c_var_4;
          }

          // conversionsValues.push({ id: "12", value: "Portal MAPFRE" });
          // womtp.c_vars[12] = "Portal MAPFRE";
          // window.c_var_12 = "Portal MAPFRE";
          // var listCVar12 = document.getElementsByClassName("c_var_12")
          // for (const index in listCVar12) {
          //     listCVar12[index].value = "Portal MAPFRE";
          // }

          conversionsValues.push({ id: "21", value: DFI.getUrlNoParams() });
          womtp.c_vars[21] = DFI.getUrlNoParams();
          window.c_var_21 = DFI.getUrlNoParams();

          if (
            getUrlParams()["origen"] == "OIM" ||
            getUrlParams()["origen"] == "APP"
          ) {
            console.log("c_var_12 CM + c_var_3 CM");
            conversionsValues.push({ id: "12", value: "METS" });
            womtp.c_vars[12] = "METS";
            window.c_var_12 = "METS";
            for (const index in listCVar12) {
              listCVar12[index].value = "METS";
            }
            conversionsValues.push({ id: "3", value: "METS" });
            womtp.c_vars[3] = "METS";
            window.c_var_3 = "METS";
          }
          /* 
                        Recoger el param origen en cualquier producto y setearlo en la c_var_26 Origen Mapfre
                    */
          if (getUrlParams()["origen"]) {
            let todosLosOrigenes = getUrlParams()["origen"];
            conversionsValues.push({ id: "26", value: todosLosOrigenes });
            womtp.c_vars[26] = todosLosOrigenes;
            window.c_var_26 = todosLosOrigenes;
          }

          let urlSinParametros = `${window.location.origin}${window.location.pathname}`;

          /* TEST A/Bs Formularios Particulares */

          if (
            urlSinParametros ==
            "https://www.mapfre.es/particulares/seguros-de-hogar/" ||
            urlSinParametros ==
            "https://www.mapfre.es/particulares/seguros-de-hogar-test/"
          ) {
            if (
              window.walmeric ==
              "AO142 Variante 0 desktop CMB sticky scroll down"
            ) {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 0 desktop CMB sticky scroll down",
              });
              womtp.c_vars[10] =
                "AO142 Variante 0 desktop CMB sticky scroll down";
              window.c_var_10 =
                "AO142 Variante 0 desktop CMB sticky scroll down";
            } else if (window.walmeric == "AO142 Variante 0 desktop CMB hero") {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 0 desktop CMB hero",
              });
              womtp.c_vars[10] = "AO142 Variante 0 desktop CMB hero";
              window.c_var_10 = "AO142 Variante 0 desktop CMB hero";
            } else if (
              window.walmeric == "AO142 Variante 0 mobile CMB sticky bar"
            ) {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 0 mobile CMB sticky bar",
              });
              womtp.c_vars[10] = "AO142 Variante 0 mobile CMB sticky bar";
              window.c_var_10 = "AO142 Variante 0 mobile CMB sticky bar";
            } else if (
              window.walmeric ==
              "AO142 Variante 1 desktop CMB sticky scroll down"
            ) {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 1 desktop CMB sticky scroll down",
              });
              womtp.c_vars[10] =
                "AO142 Variante 1 desktop CMB sticky scroll down";
              window.c_var_10 =
                "AO142 Variante 1 desktop CMB sticky scroll down";
            } else if (window.walmeric == "AO142 Variante 1 desktop CMB hero") {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 1 desktop CMB hero",
              });
              womtp.c_vars[10] = "AO142 Variante 1 desktop CMB hero";
              window.c_var_10 = "AO142 Variante 1 desktop CMB hero";
            } else if (
              window.walmeric == "AO142 Variante 1 mobile CMB sticky bar"
            ) {
              conversionsValues.push({
                id: "10",
                value: "AO142 Variante 1 mobile CMB sticky bar",
              });
              womtp.c_vars[10] = "AO142 Variante 1 mobile CMB sticky bar";
              window.c_var_10 = "AO142 Variante 1 mobile CMB sticky bar";
            }
          }

          /* CAMBIOS PARA AUTONOMOS Y EMPRESAS */
        } else if (window.location.href.includes("autonomos")) {
          conversionsValues.push({ id: "3", value: window.c_var_3 });
          womtp.c_vars[3] = window.c_var_3;

          // Gestionamos esas variables en handleProductByUrl()
          // if (digitalData[3].section_1) {
          //     const producto_c_var_4_autonomo = digitalData[3].section_1
          //     conversionsValues.push({ id: "4", value: producto_c_var_4_autonomo });
          //     womtp.c_vars[4] = producto_c_var_4_autonomo;
          //     window.c_var_4 = producto_c_var_4_autonomo;
          // }

          // conversionsValues.push({ id: "12", value: "Portal MAPFRE Autonomos" });
          // womtp.c_vars[12] = "Portal MAPFRE Autonomos";
          // window.c_var_12 = "Portal MAPFRE Autonomos";

          // var listCVar12 = document.getElementsByClassName("c_var_12")
          // for (const index in listCVar12) {
          //     listCVar12[index].value = "Portal MAPFRE Autonomos";
          // }

          conversionsValues.push({ id: "21", value: DFI.getUrlNoParams() });
          womtp.c_vars[21] = DFI.getUrlNoParams();
          window.c_var_21 = DFI.getUrlNoParams();

          /* 
                        Recoger el param origen en cualquier producto y setearlo en la c_var_26 Origen Mapfre
                    */
          if (getUrlParams()["origen"]) {
            let todosLosOrigenes = getUrlParams()["origen"];
            conversionsValues.push({ id: "26", value: todosLosOrigenes });
            womtp.c_vars[26] = todosLosOrigenes;
            window.c_var_26 = todosLosOrigenes;
          }
        } else if (window.location.href.includes("empresas")) {
          conversionsValues.push({ id: "3", value: window.c_var_3 });
          womtp.c_vars[3] = window.c_var_3;

          // Gestionamos esas variables en handleProductByUrl()
          //En esta posicion de digitalData tenemos el producto (particulares,empresas,autonomos)
          // if (digitalData[3].section_1) {
          //     const producto_c_var_4_empresas = digitalData[3].section_1
          //     conversionsValues.push({ id: "4", value: producto_c_var_4_empresas });
          //     womtp.c_vars[4] = producto_c_var_4_empresas;
          //     window.c_var_4 = producto_c_var_4_empresas;
          // }

          // handleProductByUrl();

          // conversionsValues.push({ id: "12", value: "Portal MAPFRE Empresas" });
          // womtp.c_vars[12] = "Portal MAPFRE Empresas";
          // window.c_var_12 = "Portal MAPFRE Empresas";

          // var listCVar12 = document.getElementsByClassName("c_var_12")
          // for (const index in listCVar12) {
          //     listCVar12[index].value = "Portal MAPFRE Empresas";
          // }

          conversionsValues.push({ id: "21", value: DFI.getUrlNoParams() });
          womtp.c_vars[21] = DFI.getUrlNoParams();
          window.c_var_21 = DFI.getUrlNoParams();

          /* 
                        Recoger el param origen en cualquier producto y setearlo en la c_var_26 Origen Mapfre
                    */
          if (getUrlParams()["origen"]) {
            let todosLosOrigenes = getUrlParams()["origen"];
            conversionsValues.push({ id: "26", value: todosLosOrigenes });
            womtp.c_vars[26] = todosLosOrigenes;
            window.c_var_26 = todosLosOrigenes;
          }
        }
        // en cuanto nos confirmen esto lo subimos a produccion
        // else if (window.location.href.includes("ahorro-inversion")) {
        //     conversionsValues.push({ id: "3", value: window.c_var_3 });
        //     womtp.c_vars[3] = window.c_var_3;

        //     //En esta posicion de digitalData tenemos el producto (particulares,empresas,autonomos)
        //     if(digitalData[3].section_1){
        //         const producto_c_var_4_ahorro_inversion = digitalData[3].section_1
        //         conversionsValues.push({ id: "4", value:producto_c_var_4_ahorro_inversion });
        //         womtp.c_vars[4] = producto_c_var_4_ahorro_inversion;
        //         window.c_var_4 = producto_c_var_4_ahorro_inversion;
        //     }

        //     conversionsValues.push({ id: "12", value: "Portal MAPFRE Ahorro-inversion" });
        //     womtp.c_vars[12] = "Portal MAPFRE Ahorro-inversion";
        //     window.c_var_12 = "Portal MAPFRE Ahorro-inversion";

        //     conversionsValues.push({ id: "21", value: DFI.getUrlNoParams() });
        //     womtp.c_vars[21] = DFI.getUrlNoParams();
        //     window.c_var_21 = DFI.getUrlNoParams();

        //     /*
        //         Recoger el param origen en cualquier producto y setearlo en la c_var_26 Origen Mapfre
        //     */
        //     if(getUrlParams()["origen"]){
        //         let todosLosOrigenes = getUrlParams()["origen"];
        //         conversionsValues.push({ id: "26", value: todosLosOrigenes });
        //         womtp.c_vars[26] = todosLosOrigenes;
        //         window.c_var_26 = todosLosOrigenes;
        //     }
        // }

        /* conversionsValues.push({ id: "2", value: "Callme now" });
                womtp.c_vars[2] = "Callme now";
                window.c_var_2 = 'Callme now'; */

        if (window.c_var_10)
          conversionsValues.push({ id: "10", value: window.c_var_10 });
        if (window.c_var_25)
          conversionsValues.push({ id: "25", value: window.c_var_25 });
        var EConversion = encodeURIComponent(JSON.stringify(conversionsValues));

        if (window.site === "coche") {
          var date = new Date();
          var day = date.getDay();
          var hour = date.getHours();
          if (day >= 1 && day <= 5 && hour >= 11 && hour <= 19) {
            dataLead.En_Horario_chat = "Si";
          } else {
            dataLead.En_Horario_chat = "No";
          }

          if (typeof digitalData != "undefined") {
            // risk score
            if (typeof digitalData.ScoreC != "undefined") {
              dataLead.risk_score = digitalData.ScoreC;
            }
            //pAprox
            if (typeof digitalData.pAprox != "undefined") {
              dataLead.pAprox = digitalData.pAprox;
            }
            //Diferencia
            if (typeof digitalData.diferencia != "undefined") {
              dataLead.Diferencia = digitalData.diferencia;
            }
            //Usuario
            if (typeof digitalData.usuario != "undefined") {
              dataLead.Usuario = digitalData.usuario;
            }
          }
        }

        if (typeof dataLead.verifyLeadId !== "undefined")
          delete dataLead.verifyLeadId;

        var EDeclaratives = this.generateDeclarativeURL(dataLead);

        var EExternas = this.generateExtenalsURL();

        if (window.Piwik) idlead = Piwik.getAsyncTracker().getVisitorId();
        var codPresupuesto = "";
        if (
          typeof window.cod_presupuesto != "undefined" &&
          window.cod_presupuesto != "" &&
          window.cod_presupuesto != "undefined"
        ) {
          codPresupuesto = window.cod_presupuesto;
        } else {
          try {
            if (~window.location.href.indexOf("calcular-seguros-coche")) {
              codPresupuesto = digitalData.quotation_id;
              if (typeof codPresupuesto == "undefined") {
                codPresupuesto = "";
              }
            } else {
              codPresupuesto = JSON.parse(localStorage.getItem("autosData"))
                .dataModel.numPresupuestoRUP;
              if (typeof codPresupuesto == "undefined") {
                codPresupuesto = "";
              }
            }
          } catch (error) {
            codPresupuesto = "";
          }
        }

        // Alta vÃ­a DelioCLient
        DAL.Ajax({
          type: "jsonp",
          url:
            "https://ws.walmeric.com/provision/wsclient/client_addlead.html" +
            "?idTag=" +
            DELIO.Mapfre.global.idTagDelioClient +
            "&idlead=" +
            idlead +
            "&phone=" +
            window.phone +
            "&verifyLeadId=NO" +
            //Con estos dos parametros comprobamos que no hubo mas leads con ese phone en los ultimos 15 dias
            "&nombre=" +
            window.wm_nombre +
            duplicateWindow +
            EDeclaratives +
            "&url_Conversion_Completa=" +
            urlConversion +
            "&cod_presupuesto=" +
            codPresupuesto +
            "&format=jsonp" +
            "&EConversion=" +
            EConversion +
            EExternas,
        }).done(function (response) {
          console.log("add! data: ", response);

          // Añade el showImpression cuando la modal de gracias aparece
          if (window.site === "vida" || window.site === "bici") {
            const messageForModal = "pop up gracias";
            showImpression(messageForModal);
            console.log("añadiendo impression de pop up");
          }

          window.gracias(response);
        });
      },

      /*
            |---------------------------------------------------------------------------
            | función para que divisadero genere un lead
            |---------------------------------------------------------------------------
            */
      diviAddLead: function (phone, negocio) {
        if (negocio === "mascotas") {
          DELIO.cvnegocio = true;
        }

        window.phone = phone;
        DELIO.Mapfre.newFuncionality.addLead();
        var dmv = new DMV();
        D3P.Modal = dmv;
        var txt =
          '<div class="DCS-Form">\
                <div class="DCS-headerForm">\
                    <div class="DCS-headerFormTitle"> Gracias </div>\
                    <div class="DCS-headerFormClose"> <img src="https://t.womtp.com/slider/c/mapfre/es/click2call/dev/components/img/cross.png" alt=""> </div>\
                </div>\
                <div class="DCS-bodyForm">\
                    <div class="DCS-bodyFormMessage">En un momento se pondr&aacute; un agente en contacto con usted.</div>\
                </div>\
            </div>';
        dmv.open();
        document.querySelector("#dmv-close").style.display = "none";
        dmv.setContent(txt);
        document
          .getElementsByClassName("DCS-headerFormClose")[0]
          .addEventListener("click", dmv.close);
      },

      /*
            |---------------------------------------------------------------------------
            | Listener que se lanza cuando cambia la step del cotizador
            |---------------------------------------------------------------------------
            */
      angularDatalayerListener: function () {
        DELIO.Mapfre.datalayerInfo = sessionStorage.getItem("wm_datalayerInfo")
          ? JSON.parse(sessionStorage.getItem("wm_datalayerInfo"))
          : {};
        var scopeInfo = "";

        //estas son las etiquetas del RP que se iran actualizando con las demas
        var userLabels = {
          EDeclaratives: {},
          EConversion: [
            { id: "4", value: changeOrigenVida(DELIO.Mapfre.getProduct()) },
          ],
        };

        //cargo el script de prioridades
        //funcion de carga de prioridades condicionadas

        DELIO.Mapfre.loadScript(
          "https://t.womtp.com/slider/c/mapfre/es/priiority/priorityIVR.js",
          function () {
            window.userLabels = DELIO.Mapfre.newFuncionality.getPriorityIVR();

            if (DELIO.Mapfre.getProduct() == "Hogar") {
              window.userLabels =
                DELIO.Mapfre.newFuncionality.getPriorityIVRwithOrigen(
                  "Callme Now"
                );
              window.userLabelsDRP =
                DELIO.Mapfre.newFuncionality.getPriorityIVRwithOrigen(
                  "Ringpool"
                );
            }
          }
        );

        DELIO.hogarSetTrue = function () {
          DELIO.tipoVivienda = true;
          DELIO.metrosConstruidos = true;
          DELIO.numeroHabitacionesBanios = true;
          DELIO.anioConstruccion = true;
          DELIO.cp = true;
          DELIO.hipoteca = true;
          DELIO.uso = true;
          DELIO.sistemaProteccionDomotica = true;
          DELIO.sistemasNoElectronicos = true;
          DELIO.capitalContinentePropietario = true;
          DELIO.capitalContenido = true;
          DELIO.documentoIdentidad = true;
          DELIO.direccion = true;
          DELIO.hPrecio = true;
        };

        DELIO.cocheSetTrue = function () {
          DELIO.cCompaliaSeguros = true;
          DELIO.cTodasAseguradoras = true;
          DELIO.cMatriculaMoto = true;
          DELIO.cMatricula = true;
        };

        //a falta de un evento que se lance al cambiar de step uso un intervalo
        if (window.site === "hogar") {
          DELIO.hogarSetTrue();
          DELIO.Mapfre.newFuncionality.hogarTakeTarificator();
        }
        if (window.site === "coche" || window.site === "autos") {
          DELIO.cocheSetTrue();
          DELIO.Mapfre.newFuncionality.cocheTakeTarificator();
        }
        setInterval(function () {
          scopeInfo = DELIO.Mapfre.newFuncionality.getLeadInfo();
          //recogemos  los valores rellenados  del formulario que tiene el scope de angular, si falla al recoger la info del scope y obtenemos undefined, no lo grabamos
          if (
            scopeInfo &&
            JSON.stringify(DELIO.Mapfre.datalayerInfo) !==
            JSON.stringify(scopeInfo)
          ) {
            DELIO.Mapfre.datalayerInfo = scopeInfo;
            sessionStorage.setItem(
              "wm_datalayerInfo",
              JSON.stringify(scopeInfo)
            );
          }
          if (scopeInfo && window.digitalDataDeclaratives == true) {
            DELIO.Mapfre.datalayerInfo = scopeInfo;
            sessionStorage.setItem(
              "wm_datalayerInfo",
              JSON.stringify(scopeInfo)
            );
          }
        }, 5000);
      },

      /*
            |---------------------------------------------------------------------------
            | Devuelve la info de prioridades condicionadas
            |---------------------------------------------------------------------------
            */
      getPriorityIVR: function () {
        var site = window.site || changeOrigenVida(DELIO.Mapfre.getProduct());
        var step = this.getStep();
        var info = "";
        //si estamos en hogar o autos en el step 1, ponemos scoringIVR en false
        /*if( (site == "coche" || site ==  "moto" || site ==  "autos"  || site == "hogar")  && step == 1) {
     
                    info = window.priorityIvr(window.c_var_4, localizacion.global, "", false);
     
                //por defecto se llama a la funcion sin falsear los datos
                } else {*/

        info = window.priorityIvr(window.c_var_4, localizacion.global);
        /* }*/

        return info;
      },

      getPriorityIVRwithOrigen: function (origen) {
        var info = "";

        info = window.priorityIvrWithOrigen(
          origen,
          window.c_var_4,
          localizacion.global
        );

        return info;
      },

      /*
            |---------------------------------------------------------------------------
            | Devuelve la info del scope de angular referente al rellenado del cotizador
            |---------------------------------------------------------------------------
            */
      getLeadInfo: function () {
        var site =
          window.site ||
          changeOrigenVida(DELIO.Mapfre.getProduct().toLowerCase());
        var data;
        switch (site) {
          case "coche" || "moto" || "autos":
            data = this.getLeadInfoAutos(data);

            break;

          case "moto":
            data = this.getLeadInfoAutos(data);

            break;

          case "salud":
            data = this.getSaludData();

            break;

          case "hogar":
            data = this.getHogarData();

            break;

          case "vida":
            data = {};

            break;

          case "jubilacion":
            data = {};

            break;

          case "comunidades":
            data = {};

            break;

          case "decesos":
            data = {};

            break;

          case "ahorro":
            data = {};

            break;
        }

        return data;
      },

      getLeadInfoAutos: function (data) {
        // Si es Antiguo Tarificador = localStorage, si es el nuevo
        if (~window.location.href.indexOf("calcular-seguro-coches")) {
          data = JSON.parse(localStorage.autosData).dataModel;
        } else if (~window.location.href.indexOf("calcular-seguros-coche")) {
          data = digitalData;
          window.digitalDataDeclaratives = true;
        }

        return data;
      },

      /*
            |---------------------------------------------------------------------------
            | Devuelve la info del scope de angular referente al rellenado del cotizador
            |---------------------------------------------------------------------------
            */
      getLeadLabels: function (dataLead, isRM) {
        //recojo todas las declarativas del script de priority IVR
        for (var dec in window.userLabels.EDeclaratives) {
          dataLead[dec] = window.userLabels.EDeclaratives[dec];
        }

        //comprobacion de RM o no RM
        if (isRM) {
          var index, lbName, lbValue;
          //array de elementos que queremos recoger del datalayer

          var declarativeMap = this.getDeclarativeMap();

          //AÃ‘ADO los valores del datalayer a la info del lead
          for (index in declarativeMap) {
            //si el valor no es undefined se enviaran
            if (DELIO.Mapfre.datalayerInfo[index]) {
              lbName = declarativeMap[index];
              lbValue = DELIO.Mapfre.datalayerInfo[index];
              dataLead[lbName] = lbValue;
            }
          }
          if (dataLead["Fecha de nacimiento"]) {
            dataLead["Fecha de nacimiento"] =
              dataLead["Fecha de nacimiento"].day +
              "/" +
              dataLead["Fecha de nacimiento"].month +
              "/" +
              dataLead["Fecha de nacimiento"].year;
          }

          // añadir los valores de RM
          var rmParams = JSON.parse(
            DELIO.Mapfre.getCookie("remoteManager") ||
            DELIO.Mapfre.RM.getStorage()
          );

          for (index in rmParams) {
            lbName = rmParams[index].name;
            lbValue = rmParams[index].value;
            dataLead[lbName] = lbValue;
          }

          //determinacion tipo de horario que estamos: fuera de horario, fuera de horario fin de semana o dentro de horario
          if (
            !DELIO.Mapfre.validator.scheduleValid({
              initDay: 1,
              finishDay: 5,
              initHour: 9,
              finishHour: 19,
            })
          ) {
            dataLead.horario = "fh";

            //comprobamos si esta en fuera de horario en fin de semana.
            var now = new Date();
            var day = now.getDay();
            var hour = now.getHours();
            //si es viernes,sabado o domingo
            if ((day === 5 && hour > 19) || day === 6 || day === 0) {
              dataLead.horario = "fhd";
            }
          } else {
            dataLead.horario = "dh";
          }

          if (window.site != "vida" && window.site != "jubilacion") {
            dataLead.app = "remote_manager";
          }

          //recoleccion de la fecha YYYY/MM/DD HH:mm:ss
          var d = new Date(),
            fecha =
              [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
              " " +
              [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");

          dataLead.fechaRegistroRM = fecha;

          if (dataLead.Nombre && dataLead.Nombre.toLowerCase() === "test") {
            dataLead.app = "test_rm";
          }
          //declarativas extras que no se pueden recoger del datalayer directamente
          this.setExtraDeclaratives(dataLead);
        }

        return dataLead;
      },

      /*
            |---------------------------------------------------------------------------
            | Determina si es RM dependiendo el site
            |---------------------------------------------------------------------------
            */

      getIsRM: function () {
        var isRM = false;

        //checkeamos si las condiciones del site enviado haber si debe enviarse a RM
        switch (window.site) {
          //queremos enviar a RM cuando haya precio visto
          case "coche" || "moto" || "autos":
            //modalidades es el array del datalayer donde se guardan los precios de los seguros
            if (this.getStep() > 1) {
              isRM = true;
            }

            break;
          //salud siempre va a RM
          case "salud":
            //if ( !DELIO.Mapfre.validator.scheduleValid({ initDay: 1, finishDay: 5, initHour: 10, finishHour: 19 }) || this.getStep() > 1 ) {

            isRM = true;
            //}

            break;

          //solo queremos enviar a RM cuando sea fuera de horario
          case "hogar":
            if (this.getStep() > 1) {
              isRM = true;
            }

            break;
          case "vida":
            isRM = true;

            break;

          case "jubilacion":
            isRM = true;

            break;

          case "bici":
            isRM = true;

            break;

          case "dental":
            isRP = true;

            break;

          case "accidentes":
            isRP = true;

            break;

          case "lex":
            isRP = true;

            break;

          case "ahorro":
            isRM = true;

            break;

          //en caso de que no sea ninguno de estos site se devolvera false
          default:
            break;
        }

        return isRM;
      },
      /*
            |---------------------------------------------------------------------------
            | Devuelve el paso del site que le envias
            |---------------------------------------------------------------------------
            */
      getStep: function () {
        var step = 1;

        //checkeamos si las condiciones del site enviado haber si debe enviarse a RM
        switch (window.site) {
          //queremos enviar a RM cuando haya precio visto
          case "coche":
            step = this.getStepAuto(step);

            break;

          case "moto":
            step = this.getStepAuto(step);

            break;

          //queremos enviar a RM cuando haya precio visto
          case "autos":
            if (window.location.href.indexOf("test=step") > -1) {
              step = this.getStepAuto(step);
            } else {
              //la step 2 y en adelante tienen la variable modalidad
              if (
                DELIO.Mapfre.datalayerInfo &&
                DELIO.Mapfre.datalayerInfo.modalidades &&
                !DELIO.Mapfre.datalayerInfo.seguro
              ) {
                step = 2;
                //el datalayerInfo.segur osolo aparece cuando has seleccionado uno de los seguros
              } else if (
                DELIO.Mapfre.datalayerInfo &&
                DELIO.Mapfre.datalayerInfo.seguro
              ) {
                step = 3;
              }

              if (~location.href.indexOf("fin-contratacion")) {
                step = 4;
              }
            }

            break;

          case "salud":
            if (
              DELIO.Mapfre.datalayerInfo &&
              DELIO.Mapfre.datalayerInfo.precio0
            ) {
              step = 2;
            }
            if (window.location.href.includes("tomador-titular")) {
              step = 3;
            }

            break;

          case "hogar":
            if (
              DELIO.Mapfre.datalayerInfo &&
              DELIO.Mapfre.datalayerInfo.precio0
            ) {
              step = 2;
            }

            if (
              DELIO.Mapfre.datalayerInfo &&
              DELIO.Mapfre.datalayerInfo.seguro_seleccionado
            ) {
              step = 3;
            }

            break;
          case "vida":
            if (~location.href.indexOf("precio")) {
              step = 2;
            }

            break;

          case "jubilacion":
            if (~location.href.indexOf("simulacion")) {
              step = 2;
            }

            break;

          case "mascotas":
            if (~location.href.indexOf("insurancePrice")) {
              step = 2;
              window.nextStepActive = true;
            }

            if (
              ~location.href.indexOf("contractInsuranceData") &&
              window.nextStepActive
            ) {
              step = 3;
            }

            break;

          case "viajes":
            if (window.location.href.indexOf("precios") > -1) {
              step = 2;
              window.nextStepActive = true;
            }

            if (
              window.location.href.indexOf("datos-tomador") > -1 &&
              window.nextStepActive
            ) {
              step = 3;
            }
            // if( !~location.href.indexOf("datos-tomador") &&  !~location.href.indexOf("precio")  && window.nextStepActive) {
            //     step = 3;
            // }

            break;

          case "bici":
            if (~location.href.indexOf("insurancePrice")) {
              step = 2;
              window.nextStepActive = true;
            } else if (
              !~location.href.indexOf("insuranceData") &&
              !~location.href.indexOf("insurancePrice") &&
              window.nextStepActive == true
            ) {
              step = 3;
            }

            break;

          case "dental":
            if (~location.href.indexOf("insurancePrice")) {
              step = 2;
              window.nextStepActive = true;
            } // Añado activador apartir de aqui paso 3
            else if (
              ~location.href.indexOf("contractInsuranceData") &&
              !~location.href.indexOf("insurancePrice") &&
              window.nextStepActive == true
            ) {
              step = 3;
            }

            break;

          case "accidentes":
            if (~location.href.indexOf("calculo-de-cuota")) {
              step = 2;
              window.nextStepActive = true;
            } // Añado activador apartir de aqui paso 3
            else if (
              !~location.href.indexOf("calculo-de-cuota") &&
              window.nextStepActive == true
            ) {
              step = 3;
            }

            break;

          case "lex":
            if (~location.href.indexOf("insurancePrice")) {
              step = 2;
              window.nextStepActive = true;
            } // Añado activador apartir de aqui paso 3
            else if (
              !~location.href.indexOf("insurancePrice") &&
              window.nextStepActive == true
            ) {
              step = 3;
            }

            break;

          case "comunidades":
            if (~location.href.indexOf("tarificaSeguro")) {
              step = 2;
            }

            break;

          case "decesos":
            if (~location.href.indexOf("calculation")) {
              step = 2;
              window.nextStepActive = true;
            }

            if (
              !~location.href.indexOf("infoCollection") &&
              !~location.href.indexOf("calculation") &&
              window.nextStepActive
            ) {
              step = 3;
            }

            break;

          case "ahorro":
            if (typeof digitalData != "undefined") {
              step = digitalData.progress_id;
            }

            break;

          //en caso de que no sea ninguno de estos site se devolvera step 1
          default:
            break;
        }

        return step;
      },

      getStepAuto: function (step) {
        // Antiguo Tarificador
        if (~window.location.href.indexOf("calcular-seguro-coches")) {
          //la step 2 y en adelante tienen la variable modalidad
          if (
            DELIO.Mapfre.datalayerInfo &&
            DELIO.Mapfre.datalayerInfo.modalidades &&
            !DELIO.Mapfre.datalayerInfo.seguro
          ) {
            step = 2;

            //el datalayerInfo.segur osolo aparece cuando has seleccionado uno de los seguros
          } else if (
            DELIO.Mapfre.datalayerInfo &&
            DELIO.Mapfre.datalayerInfo.seguro
          ) {
            step = 3;
          }
        }

        // Nuevo Tarificador
        if (
          ~window.location.href.indexOf("calcular-seguros-coche") &&
          typeof digitalData !== "undefined" &&
          typeof digitalData.step_description !== "undefined"
        ) {
          // Step 2 usuario en precio
          if (
            digitalData.step_description === "presupuesto" ||
            digitalData.step_description === "presupuesto-moto"
          ) {
            step = 2;
            window.step3Active = true;
          }

          // Step 3
          if (
            window.step3Active == true &&
            digitalData.step_description != "presupuesto" &&
            digitalData.step_description != "presupuesto-moto"
          ) {
            step = 3;
          }
        }

        return step;
      },

      /*
            |---------------------------------------------------------------------------
            | Determina si es debe mostrarse RP en el site actual
            |---------------------------------------------------------------------------
            */
      getIsRP: function () {
        var isRP = false;
        var site =
          window.site ||
          changeOrigenVida(DELIO.Mapfre.getProduct().toLowerCase());
        var step = this.getStep();

        switch (site) {
          //queremos enviar a RM cuando haya precio visto
          case "coche" || "moto" || "autos":
            //modalidades es el array del datalayer donde se guardan los precios de los seguros
            /*  if( ringPoolSchedule && window.innerWidth &&  window.innerWidth < 830   && step == 1) {
     
                             isRP = true;
                         } */
            isRP = false;

            break;

          case "moto":
            isRP = false;

            break;

          //no se muestra RP en salud
          case "salud":
            //if ( (window.innerWidth &&  window.innerWidth < 640 ) && DELIO.Mapfre.validator.scheduleValid({ initDay: 1, finishDay: 5, initHour: 10, finishHour: 19 })) {

            isRP = false;
            //}

            break;
          //solo queremos mostrar RP en horario cuando sea movil
          case "hogar":
            /* if ( (window.innerWidth &&  window.innerWidth < 830 ) && DELIO.Mapfre.validator.scheduleValid({ initDay: 1, finishDay: 5, initHour: 10, finishHour: 19 }) && step == 1 ) {
     
                            isRP = true;
                        } */
            isRP = false;

            break;

          case "vida":
            isRP = false;

            break;

          case "jubilacion":
            isRP = false;

            break;

          case "bici":
            isRP = false;

            break;

          case "viajes":
            isRP = false;
            break;

          case "comunidades":
            isRP = false;

            break;

          case "decesos":
            isRP = false;

            break;

          //en caso de que no sea ninguno de estos site
          default:
            if (
              ringPoolSchedule &&
              window.innerWidth &&
              window.innerWidth < 640
            ) {
              isRP = true;

              if (window.location.href.indexOf("calcular-seguro-viaje") > -1) {
                isRP = false;
              }
            }

            break;
        }

        return isRP;
      },

      /*
            |---------------------------------------------------------------------------
            | devuelve el servicio correcto por producto
            |---------------------------------------------------------------------------
            */
      getRPService: function () {

        const dayOfTheWeek = new Date().getDay();

        var service = "54CCB75DC8DEE442010E600435372103";
        // const mutation = new MutationObserver(() => {

        const constinerDate_text = document.getElementsByClassName("date_text")[0];

        // if (constinerDate_text) {

        switch (site) {
          case "coche":
            service = dayOfTheWeek != 6 ? "54CCB75DC8DEE442010E600435372103" : "17086A095B551C891B113056132B1803";
            constinerDate_text.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
            break;

          case "autos":
            service = "54CCB75DC8DEE442010E600435372103";
            break;

          case "moto":
            service = dayOfTheWeek != 6 ? "54CCB75DC8DEE442010E600435372103" : "17086A095B551C891B113056132B1803";
            constinerDate_text.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
            break;

          case "viajes":
            service = "4EDF0B5AF099371B160F123450115B06";

            break;

          case "mascota":
            service = "528D825D382029C2740F1E4E37381C09";
            // service = "8F5262A07631F55B620E600653145F00"; // La de hogar

            break;

          case "mascotas":
            service = "528D825D382029C2740F1E4E37381C09";

            break;

          case "salud":
            service = "607439EAFFAC0339D50E60065E574602";

            break;

          case "hogar":
            service = dayOfTheWeek != 6 ? "8F5262A07631F55B620E600653145F00" : "AC29FDCD421C374E8811305618133806";
            constinerDate_text.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
            break;

          //en caso de que no sea ninguno de estos site
          default:
            break;
        }

        return service;
        // }

        // });

        // mutation.observe(document.body, { childList: true, subtree: true });
      },

      /*
            |---------------------------------------------------------------------------
            | getRPDefaultPhone
            |---------------------------------------------------------------------------
            */
      getRPDefaultPhone: function () {
        var phone = "910807524";

        switch (site) {
          case "coche" || "moto" || "autos":
            phone = "910807524";
            break;

          case "salud":
            phone = "910807525";

            break;

          case "hogar":
            phone = "910807523";

            break;

          //en caso de que no sea ninguno de estos site
          default:
            break;
        }

        return phone;
      },

      /*
            |---------------------------------------------------------------------------
            | General el string para enviar las etiquetas declarativas a traves de la url
            |---------------------------------------------------------------------------
            */
      generateDeclarativeURL: function (data) {
        data["politica"] = "si";
        data["version politica privacidad"] = "Mapfre Tech V2";

        var declarativeURL = "";
        for (var declarativaElement in data) {
          declarativeURL +=
            "&" + declarativaElement + "=" + data[declarativaElement];
        }

        return decodeURIComponent(declarativeURL);
      },

      /*
            |---------------------------------------------------------------------------
            | General el string para enviar las etiquetas declarativas a traves de la url
            |---------------------------------------------------------------------------
            */
      generateExtenalsURL: function () {
        var externalURL = "";
        for (var extena in window.userLabels.EExternals) {
          externalURL +=
            "&ete_" +
            window.userLabels.EExternals[extena].id +
            "=" +
            window.userLabels.EExternals[extena].option;
        }

        return decodeURIComponent(externalURL);
      },

      /*
            |---------------------------------------------------------------------------
            | Devuelve la provincia del cp que le enviamos
            |---------------------------------------------------------------------------
            */
      getProvincia: function (codigo) {
        var numeroPostal = codigo;
        var expresionRegular1 = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/; //<--- con esto vamos a validar el numero
        var expresionRegular2 = /\s/; //<--- con esto vamos a validar que no tenga espacios en blanco
        var provincias = [
          "ARABA/ALAVA",
          "Albacete",
          "Alicante",
          "Almeria",
          "Avila",
          "Badajoz",
          "Baleares",
          "Barcelona",
          "Burgos",
          "Caceres",
          "Cadiz",
          "Castellon",
          "Ciudad Real",
          "Cordoba",
          "Coruña",
          "Cuenca",
          "Gerona",
          "Granada",
          "Guadalajara",
          "Guipuzcoa",
          "Huelva",
          "Huesca",
          "Jaen",
          "Leon",
          "Lerida",
          "La Rioja",
          "Lugo",
          "Madrid",
          "Malaga",
          "Murcia",
          "Navarra",
          "Orense",
          "Asturias",
          "Palencia",
          "Las Palmas",
          "Pontevedra",
          "Salamanca",
          "Santa Cruz De Tenerife",
          "Cantabria",
          "Segovia",
          "Sevilla",
          "Soria",
          "Tarragona",
          "Teruel",
          "Toledo",
          "Valencia",
          "Valladolid",
          "BIZKAIA",
          "Zamora",
          "Zaragoza",
          "Ceuta",
          "Melilla",
        ];

        if (numeroPostal === "") {
          return false;
        } else if (expresionRegular2.test(numeroPostal)) {
          return false;
        } else if (!expresionRegular1.test(numeroPostal)) {
          return false;
        } else {
          var codigoProvincia = parseInt(numeroPostal.substring(0, 2)) - 1;

          if (codigoProvincia < 52) {
            return provincias[codigoProvincia];
          } else {
            return false;
          }
        }
      },

      /*
             |---------------------------------------------------------------------------
             | Devuelve el mapeo de los nombre que tiene las etiquetas en el datalayer y como tienen que llamarse en delio
             |---------------------------------------------------------------------------
             */
      getDeclarativeMap: function () {
        var map = {};
        switch (window.site) {
          //queremos enviar a RM cuando haya precio visto
          case "coche" || "moto" || "autos":
            //la step 2 y en adelante tienen la variable modalidad

            //Mapeamos etiquetas dependiendo del tarificador: Nuevo, Antiguo.
            if (window.digitalDataDeclaratives == true) {
              map = {
                completeName: "Nombre",
                postal_code: "Codigo_postal",
                gearbox: "Cambio",
                fuel: "Combustible",
                registration_year: "Fecha_1_matriculacion",
                drive_license_date: "Fecha_permiso",
                garage: "Garaje",
                brand: "Marca",
                model: "Modelo",
                identification: "N_documento",
                puertas: "N_puertas",
                potency: "Potencia",
                policyholder_gende: "Sexo",
                product_type: "Tipo_de_vehiculo",
                step_version: "Version",
                birth_date: "Fecha de nacimiento",
                other_insurance_company: "Compañia Actual",
              };
            } else {
              map = {
                completeName: "Nombre",
                CP: "Codigo_postal",
                gearBoxName: "Cambio",
                combustibleName: "Combustible",
                fechaMatriculacion: "Fecha_1_matriculacion",
                fechaLicencia: "Fecha_permiso",
                garageName: "Garaje",
                brandName: "Marca",
                modelName: "Modelo",
                identification: "N_documento",
                puertas: "N_puertas",
                potencia: "Potencia",
                genereName: "Sexo",
                tipoVehiculo: "Tipo_de_vehiculo",
                versionName: "Version",
                birthdate: "Fecha de nacimiento",
                otherCompany: "Compañia Actual",
              };
            }

            break;

          case "salud":
            map = {
              coberturasList: "Garantia_bucal",
              numeroAsegurados: "Numero_asegurados",
              coberturaHospitalizacion: "Asistencia_hospitalaria",
              nombreCompleto: "Nombre_y_apellidos",
              numeroAsegurados: "Numero_asegurados",
              precio0: "Asistencia_sanitaria_premier",
              precio1: "Asistencia_sanitaria_plus",
              precio2: "Asistencia_sanitaria_supra",
              precio3: "Reembolso",
              scFechaInicioSeguro: "Fecha_inicio_de_seguro",
              scFechaNacimiento: "Fecha_nacimiento",
              scProduct: "Producto_Seleccionado",
              scProvincia: "Provincia",
              scSexo: "Sexo",
              telefono: "Telefono",
              cp: "Codigo_postal",
            };

            break;

          case "hogar":
            map = {
              anio_construccion: "anio_construccion",
              anio_rehabilitacion: "anio_rehabilitacion",
              asegurarContenido: "asegurar_contenido",
              asegurarContinentePropietario: "asegurar_continente_propietario",
              calidad: "calidad",
              capital_contenido: "capital_contenido",
              capital_conteniente: "capital_conteniente",
              codigo_postal: "codigo_postal",
              correoElectronico: "email",
              fecha_inicio: "fecha_inicio_seguro",
              hipoteca: "hipoteca",
              metros_construidos: "metros_construidos",
              numero_banios: "numero_banios",
              numero_documento: "numero_documento",
              numero_habitaciones: "numero_habitaciones",
              otroSeguro: "tiene_otro_seguro_mapfre",
              precio_seleccionado: "precio_seleccionado",
              regimen_vivienda: "regimen_vivienda",
              seguro_seleccionado: "seguro_seleccionado",
              sistemasElectronicos: "sistemas_electronicos",
              sistemas_no_electronicos: "sistemas_no_electronicos",
              precio0: "Hogar_Basico",
              precio1: "Hogar_Familiar",
              precio2: "Hogar_Total",
              precio3: "Hogar_Platino",
              "identificadorDatosTomador-field": "identificador",
              telefonoMovil: "phone",
              tipoVivienda: "tipo_vivienda",
              tipo_documento: "tipo_documento",
              uso: "uso_vivienda",
              complementoDireccion: "complemento_direccion",
              viviendaRehab: "vivienda_rehabilitada",
              Edificio: "edificio",
              capital_continente: "capital_continente",
              capital_de_contenido: "capital_de_contenido",
              capital_de_continente: "capital_de_continente",
              construccion: "construccion",
              proteccion_domotica: "proteccion_domotica",
              regimen: "regimen",
              sistemaProtecciondomotica: "sistemaProtecciondomotica",
              sistemas_no_electronicos_de_seguridad:
                "sistemas_no_electronicos_de_seguridad",
              localidad: "localidad",
              tipo_de_via: "tipo_de_via",
              nombre_de_la_via: "nombre_de_la_via",
              numero: "numero",
              Cod_Ref_Hogar_Tu_Eliges: "Referencia_NSE_Tú_Eliges",
              Cod_Ref_Hogar_Basico: "Referencia_NSE_Basico",
              Cod_Ref_Hogar_Familia: "Referencia_NSE_Familia",
              Cod_Ref_Hogar_Total: "Referencia_NSE_Total",
              Cod_Ref_Hogar_Platino: "Referencia_NSE_Platino",
            };

            break;

          //en caso de que no sea ninguno de estos site se devolvera el array vacio
          default:
            break;
        }
        return map;
      },

      /*
             |---------------------------------------------------------------------------
             | setea en el array enviado los valores extras que queremos dependiendo del site
             |---------------------------------------------------------------------------
             */
      setExtraDeclaratives: function (dataLead) {
        //si no se envia objeto salimos de la funcion
        if (!dataLead) {
          return false;
        }
        //variable con el datalayer
        var datalayer =
          DELIO.Mapfre.datalayerInfo ||
          JSON.parse(sessionStorage.getItem("wm_datalayerInfo")) ||
          {};

        //recojo todas las declarativas del script de priority IVR Ç

        for (var dec in window.userLabels.EDeclaratives) {
          dataLead[dec] = window.userLabels.EDeclaratives[dec];
        }
        if (window.location.href.indexOf("accion=vrt") > -1) {
          userLabels.EDeclaratives.Campanialead = "Acción Verti";
        }

        switch (window.site) {
          // queremos las declarativas de : Provincia, precio de seguros
          case "coche" || "moto" || "autos":
            //provincia
            dataLead.Provincia = this.getProvincia(datalayer.CP);

            //tipos de seguro con sus precios
            for (var modalidad in DELIO.Mapfre.datalayerInfo.modalidades) {
              lbName =
                "Precio_" +
                DELIO.Mapfre.datalayerInfo.modalidades[modalidad].bloque +
                "_" +
                DELIO.Mapfre.datalayerInfo.modalidades[modalidad].denominacion;
              lbValue = DELIO.Mapfre.datalayerInfo.modalidades[modalidad].prima;
              dataLead[lbName] = lbValue;
            }

            //tipos de seguro con sus precios Nuevo tarificador coche
            // if(digitalDataDeclaratives == true && typeof digitalDataDeclaratives != undefined) {
            if (
              typeof digitalData != "undefined" &&
              digitalData.dataModel &&
              typeof digitalData.dataModel != undefined
            ) {
              if (
                typeof digitalData != "undefined" &&
                digitalData.dataModel.modalidades &&
                typeof digitalData.dataModel.modalidades != undefined
              ) {
                for (var modalidad in digitalData.dataModel.modalidades) {
                  lbName =
                    "Precio_" +
                    digitalData.dataModel.modalidades[modalidad].bloque +
                    "_" +
                    digitalData.dataModel.modalidades[modalidad].denominacion;
                  lbValue = digitalData.dataModel.modalidades[modalidad].prima;
                  dataLead[lbName] = lbValue;
                }
              }
            }

            break;

          case "salud":
            //provincia
            dataLead.Provincia =
              DELIO.Mapfre.getCookie("scProvincia") ||
              this.getProvincia(datalayer.cp);
            dataLead.fuera_horario_salud_rm =
              dataLead.horario &&
                (dataLead.horario == "fh" || dataLead.horario == "fhd")
                ? "SI"
                : "NO";

            if (this.getStep() == 1) delete dataLead.app;

            break;

          case "hogar":
            var escaleraOPiso = DELIO.Mapfre.datalayerInfo["escalera"]
              ? DELIO.Mapfre.datalayerInfo["escalera"]
              : DELIO.Mapfre.datalayerInfo["piso"];
            if (DELIO.Mapfre.datalayerInfo["fechanacimiento-input-first"]) {
              dataLead.fecha_nacimiento =
                DELIO.Mapfre.datalayerInfo["fechanacimiento-input-first"] +
                "/" +
                DELIO.Mapfre.datalayerInfo["fechanacimiento-input-second"] +
                "/" +
                DELIO.Mapfre.datalayerInfo["fechanacimiento-input-third"];
            }

            if (DELIO.Mapfre.datalayerInfo["nombre"]) {
              dataLead.nombre_completo =
                DELIO.Mapfre.datalayerInfo["nombre"] +
                " " +
                DELIO.Mapfre.datalayerInfo["1Apellido"] +
                " " +
                DELIO.Mapfre.datalayerInfo["2Apellido"];
            }

            if (DELIO.Mapfre.datalayerInfo["nombreDeViaDatosTomador"]) {
              dataLead.direccion_exacta =
                DELIO.Mapfre.datalayerInfo["nombreDeViaDatosTomador"] +
                ", " +
                DELIO.Mapfre.datalayerInfo["numeroDireccionDatosTomador"] +
                ", " +
                escaleraOPiso +
                DELIO.Mapfre.datalayerInfo["puerta"];
            }

            if (
              this.getProvincia(DELIO.Mapfre.datalayerInfo["codigo_postal"])
            ) {
              dataLead.provincia = this.getProvincia(
                DELIO.Mapfre.datalayerInfo["codigo_postal"]
              );
            }

            if (this.getStep() == 1) {
              delete dataLead.app;
            }

            break;

          case "vida":
            dataLead.Provincia = this.getProvincia(window.wm_cp);

            break;

          case "jubilacion":
            dataLead.Provincia = this.getProvincia(window.wm_cp);
            dataLead.nombre = window.wm_nombre;
            dataLead.fecha = window.wm_fecha;

            break;

          case "ahorro":
            dataLead.codigo_postal = window.wm_cp;
            dataLead.nombre_y_apellidos = window.wm_nombre;
            dataLead.formulario = window.wm_formulario;
            dataLead.Provincia = this.getProvincia(window.wm_cp);

            break;

          default:
            break;
        }
      },

      /*
             |---------------------------------------------------------------------------
             | SALUD DATA
             |---------------------------------------------------------------------------
             */

      getSaludData: function () {
        this.saludListener();

        (DELIO.Mapfre.datalayerInfo["scFechaInicioSeguro"] =
          DELIO.Mapfre.getCookie("scFechaInicioSeguro")
            ? DELIO.Mapfre.getCookie("scFechaInicioSeguro")
            : ""),
          (DELIO.Mapfre.datalayerInfo["scFechaNacimiento"] =
            DELIO.Mapfre.getCookie("scFechaNacimiento")
              ? DELIO.Mapfre.getCookie("scFechaNacimiento")
              : ""),
          (DELIO.Mapfre.datalayerInfo["scNumAsegurados"] =
            DELIO.Mapfre.getCookie("scNumAsegurados")
              ? DELIO.Mapfre.getCookie("scNumAsegurados")
              : ""),
          (DELIO.Mapfre.datalayerInfo["scProduct"] = DELIO.Mapfre.getCookie(
            "scProduct"
          )
            ? DELIO.Mapfre.getCookie("scProduct")
            : ""),
          (DELIO.Mapfre.datalayerInfo["scProvincia"] = DELIO.Mapfre.getCookie(
            "scProvincia"
          )
            ? DELIO.Mapfre.getCookie("scProvincia")
            : ""),
          (DELIO.Mapfre.datalayerInfo["scSexo"] = DELIO.Mapfre.getCookie(
            "scSexo"
          )
            ? DELIO.Mapfre.getCookie("scSexo")
            : ""),
          (sessionStorage.wm_datalayerInfo = JSON.stringify(
            DELIO.Mapfre.datalayerInfo
          ));

        return DELIO.Mapfre.datalayerInfo;
      },

      saludListener: function () {
        this.stepName = "";
        try {
          window.nombre_pagina = digitalData.step_description;
        } catch (error) { }
        setInterval(function () {
          if (this.stepName !== window.nombre_pagina) {
            this.stepName = window.nombre_pagina;
            addListenersSalud();
          }
        }, 250);

        function addListenersSalud() {
          //ev que recoje los checkboxes automaticos
          document
            .querySelectorAll(".mfc-vertical-list__label")
            .forEach(function (label) {
              label.addEventListener("click", function (ev) {
                var labelName = ev.currentTarget.htmlFor;
                labelName = labelName.substring(0, labelName.length - 1);

                DELIO.Mapfre.datalayerInfo[labelName] =
                  ev.currentTarget.querySelector("p").innerHTML;

                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
              });
            });

          //evento que recoje el input del DNI
          document
            .getElementById("tipoDocumento-field")
            .addEventListener("input", function (ev) {
              DELIO.Mapfre.datalayerInfo.documento = ev.currentTarget.value;
              //grabo en el session storage
              sessionStorage.wm_datalayerInfo = JSON.stringify(
                DELIO.Mapfre.datalayerInfo
              );
            });

          //evento que recoje el input del DNI
          document
            .getElementById("nombreApellidos")
            .addEventListener("input", function (ev) {
              DELIO.Mapfre.datalayerInfo.nombreCompleto =
                ev.currentTarget.value;
              //grabo en el session storage
              sessionStorage.wm_datalayerInfo = JSON.stringify(
                DELIO.Mapfre.datalayerInfo
              );
            });

          //evento que recoje el input del DNI
          document
            .getElementById("telefono")
            .addEventListener("input", function (ev) {
              DELIO.Mapfre.datalayerInfo.telefono = ev.currentTarget.value;
              //grabo en el session storage
              sessionStorage.wm_datalayerInfo = JSON.stringify(
                DELIO.Mapfre.datalayerInfo
              );
            });

          //evento que recoge los precios
          var elements = document.querySelectorAll(
            ".mfc-price-model-list__elementList div.price"
          );
          Array.prototype.forEach.call(elements, function (element, index) {
            DELIO.Mapfre.datalayerInfo["precio" + index] = element.innerHTML;
            //grabo en el session storage
            sessionStorage.wm_datalayerInfo = JSON.stringify(
              DELIO.Mapfre.datalayerInfo
            );
          });
        }
      },

      /*
            |---------------------------------------------------------------------------
            | HOGAR DATA
            |---------------------------------------------------------------------------
            */

      getHogarData: function () {
        (DELIO.Mapfre.datalayerInfo["tipo_vivienda"] = DELIO.Mapfre.getCookie(
          "tipo_vivienda"
        )
          ? DELIO.Mapfre.getCookie("tipo_vivienda")
          : ""),
          //DELIO.Mapfre.datalayerInfo["anio_construccion"]   = DELIO.Mapfre.getCookie("anio_construccion") ? DELIO.Mapfre.getCookie("anio_construccion") : "",
          //DELIO.Mapfre.datalayerInfo["codigo_postal"]       = DELIO.Mapfre.getCookie("codigo_postal") ? DELIO.Mapfre.getCookie("codigo_postal") : "",
          //DELIO.Mapfre.datalayerInfo["metros_construidos"]  = DELIO.Mapfre.getCookie("metros_construidos") ? DELIO.Mapfre.getCookie("metros_construidos") : "",
          (DELIO.Mapfre.datalayerInfo["regimen_vivienda"] =
            DELIO.Mapfre.getCookie("regimen_vivienda")
              ? DELIO.Mapfre.getCookie("regimen_vivienda")
              : ""),
          //DELIO.Mapfre.datalayerInfo["uso"]                 = DELIO.Mapfre.getCookie("uso") ? DELIO.Mapfre.getCookie("uso") : "",
          (DELIO.Mapfre.datalayerInfo["precio_seleccionado"] =
            DELIO.Mapfre.getCookie("precio_seguro_hogar")
              ? DELIO.Mapfre.getCookie("precio_seguro_hogar")
              : ""),
          this.hogarListener();
        sessionStorage.wm_datalayerInfo = JSON.stringify(
          DELIO.Mapfre.datalayerInfo
        );

        return DELIO.Mapfre.datalayerInfo;
      },

      hogarListener: function () {
        this.stepName = "";
        try {
          window.nombre_pagina = digitalData.step_description;
        } catch (error) { }

        setInterval(function () {
          if (this.stepName !== window.nombre_pagina) {
            this.stepName = window.nombre_pagina;
            addListenersHogar();
          }
        }, 100);

        function addListenersHogar() {
          try {
            //select verticales
            document
              .querySelectorAll(".mfc-vertical-list__label")
              .forEach(function (label) {
                label.addEventListener("click", function (ev) {
                  var labelName = ev.currentTarget.htmlFor;
                  labelName = labelName.substring(0, labelName.length - 1);

                  DELIO.Mapfre.datalayerInfo[labelName] =
                    ev.currentTarget.querySelector("p").innerHTML;

                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                });
              });

            //select horizontales
            document
              .querySelectorAll(
                ".mfc-horizontal-list__container__list__item__label"
              )
              .forEach(function (label) {
                label.addEventListener("click", function (ev) {
                  var labelName = ev.currentTarget.htmlFor;
                  labelName = labelName.substring(0, labelName.length - 1);
                  DELIO.Mapfre.datalayerInfo[labelName] =
                    ev.currentTarget.querySelector("b").innerHTML;
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                });
              });

            // inputs de habitaciones y baÃ±os
            if (
              window.nombre_pagina == "numero habitaciones banios" ||
              digitalData.step_description == "numero habitaciones banios"
            ) {
              //input habitaciones
              document
                .getElementById("numHabitaciones")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["numero_habitaciones"] =
                    ev.currentTarget.value;
                  //grabo en el session storage
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                });

              //input baÃ±os
              document
                .getElementById("numHabitaciones")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["numero_banios"] =
                    ev.currentTarget.value;
                  //grabo en el session storage
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                });
            }

            //si seleccionas vivienda rehabilitada te aparece una pantalla para indicar la fecha
            if (
              window.nombre_pagina == "anio rehabilitacion" ||
              digitalData.step_description == "anio rehabilitacion"
            ) {
              document
                .getElementById("anioRehabilitacion")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["anio_rehabilitacion"] =
                    ev.currentTarget.value;
                  //grabo en el session storage
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                });
            }
            //checkboxes seguridad1
            if (
              window.nombre_pagina == "sistemas no electronicos" ||
              digitalData.step_description == "sistemas no electronicos"
            ) {
              var labelValue = "";
              var labelValueComplete = "";

              document
                .querySelectorAll("mfc-check-box__input")
                .forEach(function (label) {
                  label.addEventListener("click", function (ev) {
                    var checkboxes = document.querySelectorAll(
                      ".mfc-check-box__input:checked"
                    );
                    labelValueComplete = "";
                    for (var e = 0; e < checkboxes.length; e++) {
                      labelValue = checkboxes[e].id;
                      labelValue = labelValue.substring(4, labelValue.length);

                      labelValueComplete += "/" + labelValue;
                    }
                    DELIO.Mapfre.datalayerInfo["sistemas_no_electronicos"] =
                      labelValueComplete.substring(
                        1,
                        labelValueComplete.length
                      );
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                });
            }

            // select capitales continente
            if (
              window.nombre_pagina == "capital continente propietario" ||
              digitalData.step_description == "capital continente propietario"
            ) {
              //valores por defecto

              DELIO.Mapfre.datalayerInfo["capital_continente"] =
                document.getElementById("capitalContinentePropietario").value;
              DELIO.Mapfre.datalayerInfo["asegurarContinentePropietario"] =
                document.querySelector(
                  "input[name='asegurarContinentePropietario']:checked"
                ).value;

              //por defecto recojo el input si cambia
              document
                .getElementById("capitalContinentePropietario")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["capital_continente"] =
                    ev.currentTarget.value;
                });

              document
                .querySelectorAll("input[name='asegurarContinentePropietario']")
                .forEach(function (input) {
                  input.addEventListener("click", function (ev) {
                    //se asegura el continente SI o NO
                    DELIO.Mapfre.datalayerInfo[
                      "asegurarContinentePropietario"
                    ] = document.querySelector(
                      "input[name='asegurarContinentePropietario']:checked"
                    ).value;
                    //si esta asegurando el contenido recojo el valor del mismo
                    if (
                      DELIO.Mapfre.datalayerInfo[
                      "asegurarContinentePropietario"
                      ] === "SI"
                    ) {
                      //valor conteninete
                      DELIO.Mapfre.datalayerInfo["capital_continente"] =
                        document.getElementById(
                          "capitalContinentePropietario"
                        ).value;

                      document
                        .getElementById("capitalContinentePropietario")
                        .addEventListener("input", function (ev) {
                          DELIO.Mapfre.datalayerInfo["capital_continente"] =
                            ev.currentTarget.value;
                        });
                    }

                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                });
              document
                .querySelector("fieldset > div > ul > li:nth-child(1) > label")
                .addEventListener("click", function () {
                  DELIO.Mapfre.datalayerInfo["asegurarContinentePropietario"] =
                    "Si";
                });
              document
                .querySelector("fieldset > div > ul > li:nth-child(2) > label")
                .addEventListener("click", function () {
                  DELIO.Mapfre.datalayerInfo["asegurarContinentePropietario"] =
                    "No";
                });
              document
                .querySelector("#capitalContinentePropietario")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["capital_continente"] =
                    document.getElementById(
                      "capitalContinentePropietario"
                    ).value;
                });
            }

            //capital contenido
            if (
              window.nombre_pagina == "capital contenido" ||
              digitalData.step_description == "capital contenido"
            ) {
              //valores por defecto
              DELIO.Mapfre.datalayerInfo["capital_contenido"] =
                document.getElementById("capitalContenido").value;
              DELIO.Mapfre.datalayerInfo["asegurarContenido"] =
                document.querySelector(
                  "input[name='asegurarContenido']:checked"
                ).value;

              document
                .getElementById("capitalContenido")
                .addEventListener("input", function (ev) {
                  DELIO.Mapfre.datalayerInfo["capital_contenido"] =
                    ev.currentTarget.value;
                });

              //les pongo un listener al boton de avanzar para recoger los datos, aqui no funciona correctamente el listener de los select horizontales
              document
                .querySelectorAll("input[name='asegurarContenido']")
                .forEach(function (input) {
                  input.addEventListener("click", function (ev) {
                    //se asegura el contenido SI o NO
                    DELIO.Mapfre.datalayerInfo["asegurarContenido"] =
                      document.querySelector(
                        "input[name='asegurarContenido']:checked"
                      ).value;

                    //si esta asegurando el contenido recojo el valor del mismo
                    if (
                      DELIO.Mapfre.datalayerInfo["asegurarContenido"] === "SI"
                    ) {
                      //valor contenido
                      DELIO.Mapfre.datalayerInfo["capital_contenido"] =
                        document.getElementById("capitalContenido").value;

                      document
                        .getElementById("capitalContenido")
                        .addEventListener("input", function (ev) {
                          DELIO.Mapfre.datalayerInfo["capital_contenido"] =
                            ev.currentTarget.value;
                        });
                    }
                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                });
            }

            //si tienes otros seguros con ellos aparece una pantalla para poner tu nif/nie y numero
            if (
              window.nombre_pagina == "documento identidad" ||
              digitalData.step_description == "documento identidad"
            ) {
              getDocumentValues();
              document
                .querySelectorAll("input[name='tipoDocumento-list']")
                .forEach(function (input) {
                  input.addEventListener("click", getDocumentValues);
                });

              //setea un listener que recoge los datos de la pagina
              function getDocumentValues() {
                document
                  .getElementById("tipoDocumento-field")
                  .addEventListener("input", function (ev) {
                    //cojo los datos de tipo de documento
                    var tipoDocumento = document.querySelector(
                      "input[name='tipoDocumento-list']:checked"
                    );
                    if (tipoDocumento) {
                      DELIO.Mapfre.datalayerInfo["tipo_documento"] =
                        tipoDocumento.value;
                    }

                    //numero de documento
                    DELIO.Mapfre.datalayerInfo["numero_documento"] =
                      ev.currentTarget.value;

                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            }

            //pagina que aparecen los posibles seguros
            if (
              window.nombre_pagina === "precio" ||
              digitalData.step_description == "precio"
            ) {
              //evento que recoge los precios
              var elements = document.querySelectorAll(
                ".mfc-price-model-list__elementList div.price"
              );

              Array.prototype.forEach.call(elements, function (element, index) {
                //precio0,precio1,precio2,precio3 : son cada 1 de los precios que aparecen en la lista de precios cuando llegas al paso 2
                DELIO.Mapfre.datalayerInfo["precio" + index] =
                  element.innerHTML;
                //grabo en el session storage
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
              });

              //recoger precio seleccionado
              document
                .querySelectorAll(".mfc-link-button__green")
                .forEach(function (label) {
                  label.addEventListener("click", function (ev) {
                    //nombre seguro
                    DELIO.Mapfre.datalayerInfo["seguro_seleccionado"] =
                      ev.currentTarget
                        .closest(".mfc-price-model-list__elementList")
                        .querySelector(
                          ".mfc-price-model-list__title__insurance__label h5"
                        ).innerHTML;
                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                });
            }

            //pagina seleccion de fecha de inicio
            if (
              window.nombre_pagina === "inicio seguro" ||
              digitalData.step_description == "inicio seguro"
            ) {
              document
                .querySelectorAll(".mfc-u-calendar__days td")
                .forEach(function (label) {
                  label.addEventListener("click", function (ev) {
                    //devuelve un objeto {day: 10, month: 5, year: 2017, state: Array(1)}
                    var oDate = ev.currentTarget.getAttribute("data-day");
                    //fecha inicio
                    DELIO.Mapfre.datalayerInfo["fecha_inicio"] =
                      oDate.day + "/" + oDate.month + "/" + oDate.year;
                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                });
            }

            //datos del paso 3
            if (
              window.nombre_pagina == "tomador datos" ||
              digitalData.step_description == "tomador dato"
            ) {
              var inputsSelectors = [
                "identificadorDatosTomador-field",
                "fechanacimiento-input-first",
                "fechaNacimiento-input-second",
                "fechaNacimiento-input-third",
                "nombre",
                "1Apellido",
                "2Apellido",
                "telefonoMovil",
                "correoElectronico",
                "cpDatosTomador",
                "localidadDatosTomador",
                "provinciaDatosTomador",
                "nombreDeViaDatosTomador",
                "numeroDireccionDatosTomador",
                "restoDireccionDatosTomado",
                "escalera",
                "piso",
                "puerta",
                "complementoDireccion",
              ];

              for (var input in inputsSelectors) {
                document
                  .getElementById(inputsSelectors[input])
                  .addEventListener("change", function (ev) {
                    DELIO.Mapfre.datalayerInfo[ev.currentTarget.id] =
                      ev.currentTarget.value;
                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
      },

      cocheTakeTarificator: function () {
        setInterval(function () {
          if (~location.href.indexOf("ia-seguros")) {
            if (DELIO.cCompaliaSeguros) {
              DELIO.cocheSetTrue();
              DELIO.cCompaliaSeguros = false;
              document
                .querySelector(
                  "#main > div > div > div.main-block > div > ul:nth-child(3) > li:nth-child(3) > div"
                )
                .addEventListener("click", function () {
                  DELIO.isClientMapfre = true;

                  if (SIO.Chat.showDsa) {
                    if (DELIO.openChat) {
                      updateChat({ EDeclaratives: { cliente: "SI" } });
                    } else {
                      document.querySelector("#dsa").style.display = "none";
                    }
                  }
                });
            }
          } else if (~location.href.indexOf("todas-aseguradoras")) {
            if (DELIO.cTodasAseguradoras) {
              DELIO.cocheSetTrue();
              DELIO.cTodasAseguradoras = false;

              setTimeout(function () {
                document
                  .querySelectorAll("#list > li")
                  .forEach(function (element) {
                    element.addEventListener("click", function (event) {
                      if (
                        event.currentTarget.innerText ===
                        "MAPFRE ESPAÑA SEGUROS Y REASEGUROS, S.A."
                      ) {
                        DELIO.isClientMapfre = true;
                        if (SIO.Chat.showDsa) {
                          if (DELIO.openChat) {
                            updateChat({ EDeclaratives: { cliente: "SI" } });
                          } else {
                            document.querySelector("#dsa").style.display =
                              "none";
                          }
                        }
                      }
                    });
                  });
                var ejecutame = true;
                document
                  .querySelector("#fmf-search")
                  .addEventListener("input", function () {
                    document
                      .querySelectorAll("#list > li")
                      .forEach(function (element) {
                        element.addEventListener("click", function (event) {
                          if (
                            event.currentTarget.innerText ===
                            "MAPFRE ESPAÑA SEGUROS Y REASEGUROS, S.A."
                          ) {
                            DELIO.isClientMapfre = true;
                            if (ejecutame) {
                              ejecutame = false;
                              if (SIO.Chat.showDsa) {
                                if (DELIO.openChat) {
                                  updateChat({
                                    EDeclaratives: { cliente: "SI" },
                                  });
                                } else {
                                  document.querySelector("#dsa").style.display =
                                    "none";
                                }
                              }
                            }
                          }
                        });
                      });
                  });
              }, 500);
            }
          } else if (~location.href.indexOf("matriculaMoto")) {
            if (DELIO.cMatriculaMoto) {
              DELIO.cocheSetTrue();
              DELIO.cMatriculaMoto = false;
              if (typeof DELIO.openChat != "undefined") {
                if (DELIO.openChat === false) {
                  document.querySelector("#dsa").style.display = "none";
                  DELIO.flagChatMoto = true;
                }
              }
            }
          } else if (
            ~location.href.indexOf("matricula") &&
            !~location.href.indexOf("matriculasNuevasMoto")
          ) {
            if (DELIO.cMatricula) {
              DELIO.cocheSetTrue();
              DELIO.cMatriculaMoto = false;
              if (DELIO.flagChatMoto) {
                document.querySelector("#dsa").style.display = "block";
                DELIO.flagChatMoto = false;
              }
            }
          } else {
            DELIO.cocheSetTrue();
          }

          function updateChat(data) {
            var dataUpdateChat = JSON.stringify(data);
            var idlead = SIO.Chat.global.leadId || SIO.Chat.storage().wm_user;
            DAL.Ajax({
              type: "jsonp",
              url: "https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html",
              data: {
                data: dataUpdateChat,
                idTag: DELIO.Mapfre.global.idTagDelioClient,
                leadId: idlead,
              },
            }).done(function (dataResp) {
              console.log("DFI.updateLead() => resp", dataResp);
            });
          }
        }, 250);
      },

      hogarTakeTarificator: function () {
        setInterval(function () {
          try {
            if (~location.href.indexOf("tipo-vivienda")) {
              if (DELIO.tipoVivienda) {
                DELIO.hogarSetTrue();
                DELIO.tipoVivienda = false;
                document
                  .querySelector(
                    "fieldset > div > ul > li:nth-child(1) > label"
                  )
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["Edificio"] =
                      document.querySelector(
                        "fieldset > div > ul > li:nth-child(1) > label > p"
                      ).innerText;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector(
                    "fieldset > div > ul > li:nth-child(2) > label"
                  )
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["Edificio"] =
                      document.querySelector(
                        "fieldset > div > ul > li:nth-child(2) > label > p"
                      ).innerText;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector(
                    "fieldset > div > ul > li:nth-child(3) > label"
                  )
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["Edificio"] =
                      document.querySelector(
                        "fieldset > div > ul > li:nth-child(3) > label > p"
                      ).innerText;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                try {
                  document
                    .querySelector(
                      "fieldset > div > ul > li:nth-child(4) > label"
                    )
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["Edificio"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(4) > label > p"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                } catch (error) {
                  //en una de las dos opciones no existe
                }
              }
            } else if (~location.href.indexOf("metros-construidos")) {
              if (DELIO.metrosConstruidos) {
                DELIO.hogarSetTrue();
                DELIO.metrosConstruidos = false;
                DELIO.Mapfre.datalayerInfo["metros_construidos"] =
                  document.querySelector("#metrosConstruidos").value;
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
                document
                  .querySelector("#metrosConstruidos")
                  .addEventListener("input", function (ev) {
                    DELIO.Mapfre.datalayerInfo["metros_construidos"] =
                      document.querySelector("#metrosConstruidos").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (~location.href.indexOf("numero-habitaciones-banios")) {
              if (DELIO.numeroHabitacionesBanios) {
                DELIO.hogarSetTrue();
                DELIO.numeroHabitacionesBanios = false;
                DELIO.Mapfre.datalayerInfo["numero_habitaciones"] =
                  document.querySelector("#numHabitaciones").value;
                DELIO.Mapfre.datalayerInfo["numero_banios"] =
                  document.querySelector("#numBanos").value;
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
                document
                  .querySelector("#numHabitaciones")
                  .addEventListener("input", function (ev) {
                    DELIO.Mapfre.datalayerInfo["numero_habitaciones"] =
                      document.querySelector("#numHabitaciones").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("#numBanos")
                  .addEventListener("input", function (ev) {
                    DELIO.Mapfre.datalayerInfo["numero_banios"] =
                      document.querySelector("#numBanos").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (~location.href.indexOf("anio-construccion")) {
              if (DELIO.anioConstruccion) {
                DELIO.hogarSetTrue();
                DELIO.anioConstruccion = false;
                DELIO.Mapfre.datalayerInfo["anio_construccion"] =
                  document.querySelector("#anioConstruccion").value;
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
                document
                  .querySelector("#anioConstruccion")
                  .addEventListener("input", function (ev) {
                    DELIO.Mapfre.datalayerInfo["anio_construccion"] =
                      document.querySelector("#anioConstruccion").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (~location.href.indexOf("codigo-postal")) {
              if (DELIO.cp) {
                DELIO.hogarSetTrue();
                DELIO.cp = false;
                DELIO.Mapfre.datalayerInfo["codigo_postal"] =
                  document.querySelector("#cp").value;
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
                document
                  .querySelector("#cp")
                  .addEventListener("input", function (ev) {
                    DELIO.Mapfre.datalayerInfo["codigo_postal"] =
                      document.querySelector("#cp").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (~location.href.indexOf("hipoteca")) {
              if (DELIO.hipoteca) {
                DELIO.hogarSetTrue();
                DELIO.hipoteca = false;
                try {
                  document
                    .querySelector("fieldset > div > ul > li:nth-child(1)")
                    .addEventListener("input", function (ev) {
                      DELIO.Mapfre.datalayerInfo["hipoteca"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(1)"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                  document
                    .querySelector("fieldset > div > ul > li:nth-child(2)")
                    .addEventListener("input", function (ev) {
                      DELIO.Mapfre.datalayerInfo["hipoteca"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(2)"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                } catch (error) {
                  DELIO.hogarSetTrue();
                }
              }
            } else if (~location.href.indexOf("uso")) {
              try {
                if (DELIO.uso) {
                  DELIO.hogarSetTrue();
                  DELIO.uso = false;
                  DELIO.Mapfre.datalayerInfo["uso"] = document.querySelector(
                    "fieldset > div > ul > li:nth-child(1) > label"
                  ).innerText;
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                  document
                    .querySelector("fieldset > div > ul > li:nth-child(1)")
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["uso"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(1) > label"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                  document
                    .querySelector(
                      "fieldset > div > ul > li:nth-child(2) > label"
                    )
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["uso"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(2) > label"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });

                  setTimeout(function () {
                    DELIO.Mapfre.datalayerInfo["regimen"] =
                      document.querySelector(
                        "#regimenVivienda-input"
                      ).innerText;
                  }, 200);
                  document
                    .querySelector("#regimenVivienda-input")
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["regimen"] =
                        document.querySelector(
                          "#regimenVivienda-input"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });

                  DELIO.Mapfre.datalayerInfo["construccion"] =
                    document.querySelectorAll(
                      "fieldset > div > ul > li:nth-child(1) > label"
                    )[1].innerText;
                  sessionStorage.wm_datalayerInfo = JSON.stringify(
                    DELIO.Mapfre.datalayerInfo
                  );
                  document
                    .querySelectorAll(
                      "fieldset > div > ul > li:nth-child(1) > label"
                    )[1]
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["construccion"] =
                        document.querySelectorAll(
                          "fieldset > div > ul > li:nth-child(1) > label"
                        )[1].innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                  document
                    .querySelectorAll(
                      "fieldset > div > ul > li:nth-child(2) > label"
                    )[1]
                    .addEventListener("clickl", function (ev) {
                      DELIO.Mapfre.datalayerInfo["construccion"] =
                        document.querySelectorAll(
                          "fieldset > div > ul > li:nth-child(2) > label"
                        )[1].innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                }
              } catch (error) {
                DELIO.hogarSetTrue();
              }
            } else if (~location.href.indexOf("sistema-proteccion-domotica")) {
              if (DELIO.sistemaProteccionDomotica) {
                DELIO.hogarSetTrue();
                DELIO.sistemaProteccionDomotica = false;
                try {
                  document
                    .querySelector(
                      "fieldset > div > ul > li:nth-child(1) > label"
                    )
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["proteccion_domotica"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(1) > label"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                  document
                    .querySelector(
                      "fieldset > div > ul > li:nth-child(2) > label"
                    )
                    .addEventListener("click", function (ev) {
                      DELIO.Mapfre.datalayerInfo["proteccion_domotica"] =
                        document.querySelector(
                          "fieldset > div > ul > li:nth-child(2) > label"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    });
                } catch (error) {
                  DELIO.hogarSetTrue();
                }
              }
            } else if (~location.href.indexOf("sistemas-no-electronicos")) {
              if (DELIO.sistemasNoElectronicos) {
                DELIO.hogarSetTrue();
                DELIO.sistemasNoElectronicos = false;
                DELIO.Mapfre.datalayerInfo[
                  "sistemas_no_electronicos_de_seguridad"
                ] = "ninguno";
                sessionStorage.wm_datalayerInfo = JSON.stringify(
                  DELIO.Mapfre.datalayerInfo
                );
                var arrResp = "";

                document
                  .querySelector("div > ul > li:nth-child(1) > div")
                  .addEventListener("click", function (ev) {
                    arrResp = "";
                    if (document.querySelector("#MCA_REJAS").checked) {
                      arrResp = arrResp + " rejas en las ventanas,";
                    }
                    if (
                      document.querySelector("#MCA_PUERTA_ACORAZADA").checked
                    ) {
                      arrResp = arrResp + " puerta acorazada,";
                    }
                    if (
                      document.querySelector("#MCA_PROTECCION_JOYAS").checked
                    ) {
                      arrResp = arrResp + " caja fuerte,";
                    }
                    arrResp = arrResp.substr(1, arrResp.length - 2);

                    if (document.querySelector("#MCA_NINGUNA").checked) {
                      arrResp = "ninguno";
                    }
                    DELIO.Mapfre.datalayerInfo[
                      "sistemas_no_electronicos_de_seguridad"
                    ] = arrResp;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("div > ul > li:nth-child(2) > div")
                  .addEventListener("click", function (ev) {
                    arrResp = "";
                    if (document.querySelector("#MCA_REJAS").checked) {
                      arrResp = arrResp + " rejas en las ventanas,";
                    }
                    if (
                      document.querySelector("#MCA_PUERTA_ACORAZADA").checked
                    ) {
                      arrResp = arrResp + " puerta acorazada,";
                    }
                    if (
                      document.querySelector("#MCA_PROTECCION_JOYAS").checked
                    ) {
                      arrResp = arrResp + " caja fuerte,";
                    }
                    arrResp = arrResp.substr(1, arrResp.length - 2);

                    if (document.querySelector("#MCA_NINGUNA").checked) {
                      arrResp = "ninguno";
                    }
                    DELIO.Mapfre.datalayerInfo[
                      "sistemas_no_electronicos_de_seguridad"
                    ] = arrResp;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("div > ul > li:nth-child(3) > div")
                  .addEventListener("click", function (ev) {
                    arrResp = "";
                    if (document.querySelector("#MCA_REJAS").checked) {
                      arrResp = arrResp + " rejas en las ventanas,";
                    }
                    if (
                      document.querySelector("#MCA_PUERTA_ACORAZADA").checked
                    ) {
                      arrResp = arrResp + " puerta acorazada,";
                    }
                    if (
                      document.querySelector("#MCA_PROTECCION_JOYAS").checked
                    ) {
                      arrResp = arrResp + " caja fuerte,";
                    }
                    arrResp = arrResp.substr(1, arrResp.length - 2);

                    if (document.querySelector("#MCA_NINGUNA").checked) {
                      arrResp = "ninguno";
                    }
                    DELIO.Mapfre.datalayerInfo[
                      "sistemas_no_electronicos_de_seguridad"
                    ] = arrResp;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("div > ul > li:nth-child(4) > div")
                  .addEventListener("click", function (ev) {
                    arrResp = "";
                    if (document.querySelector("#MCA_REJAS").checked) {
                      arrResp = arrResp + " rejas en las ventanas,";
                    }
                    if (
                      document.querySelector("#MCA_PUERTA_ACORAZADA").checked
                    ) {
                      arrResp = arrResp + " puerta acorazada,";
                    }
                    if (
                      document.querySelector("#MCA_PROTECCION_JOYAS").checked
                    ) {
                      arrResp = arrResp + " caja fuerte,";
                    }
                    arrResp = arrResp.substr(1, arrResp.length - 2);

                    if (document.querySelector("#MCA_NINGUNA").checked) {
                      arrResp = "ninguno";
                    }
                    DELIO.Mapfre.datalayerInfo[
                      "sistemas_no_electronicos_de_seguridad"
                    ] = arrResp;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (
              ~location.href.indexOf("capital-continente-propietario")
            ) {
              if (DELIO.capitalContinentePropietario) {
                DELIO.hogarSetTrue();
                DELIO.capitalContinentePropietario = false;
                document
                  .querySelector("fieldset > div > ul > li:nth-child(1)")
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["capital_de_continente"] =
                      document.querySelector(
                        "#capitalContinentePropietario"
                      ).value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("fieldset > div > ul > li:nth-child(2)")
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["capital_de_continente"] = "";
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });

                try {
                  setTimeout(function () {
                    document
                      .querySelector("#capitalContinentePropietario")
                      .addEventListener("input", function (ev) {
                        DELIO.Mapfre.datalayerInfo["capital_de_continente"] =
                          document.querySelector(
                            "#capitalContinentePropietario"
                          ).value;
                        sessionStorage.wm_datalayerInfo = JSON.stringify(
                          DELIO.Mapfre.datalayerInfo
                        );
                      });
                    document
                      .querySelector("fieldset > div > ul > li:nth-child(1)")
                      .click();
                  }, 1000);
                } catch (error) {
                  console.log(error);
                  DELIO.hogarSetTrue();
                }
              }
            } else if (~location.href.indexOf("capital-contenido")) {
              if (DELIO.capitalContenido) {
                DELIO.hogarSetTrue();
                DELIO.capitalContenido = false;
                document
                  .querySelector("fieldset > div > ul > li:nth-child(1)")
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["capital_de_contenido"] =
                      document.querySelector("#capitalContenido").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("fieldset > div > ul > li:nth-child(2)")
                  .addEventListener("click", function (ev) {
                    DELIO.Mapfre.datalayerInfo["capital_de_contenido"] = "";
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });

                try {
                  setTimeout(function () {
                    document
                      .querySelector("#capitalContenido")
                      .addEventListener("input", function (ev) {
                        DELIO.Mapfre.datalayerInfo["capital_de_contenido"] =
                          document.querySelector("#capitalContenido").value;
                        sessionStorage.wm_datalayerInfo = JSON.stringify(
                          DELIO.Mapfre.datalayerInfo
                        );
                      });
                    document
                      .querySelector("fieldset > div > ul > li:nth-child(1)")
                      .click();
                  }, 1000);
                } catch (error) {
                  console.log(error);
                  DELIO.hogarSetTrue();
                }
              }
            } else if (~location.href.indexOf("documento-identidad")) {
              if (DELIO.documentoIdentidad) {
                DELIO.hogarSetTrue();
                DELIO.documentoIdentidad = false;

                document
                  .getElementById("tipoDocumento-field")
                  .addEventListener("input", function (ev) {
                    //cojo los datos de tipo de documento
                    var tipoDocumento = document.querySelector(
                      "input[name='tipoDocumento-list']:checked"
                    );
                    if (tipoDocumento) {
                      DELIO.Mapfre.datalayerInfo["tipo_documento"] =
                        tipoDocumento.value;
                    }

                    //numero de documento
                    DELIO.Mapfre.datalayerInfo["numero_documento"] =
                      ev.currentTarget.value;

                    //grabo en el session storage
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (window.nombre_pagina === "direccion") {
              if (DELIO.direccion) {
                DELIO.hogarSetTrue();
                DELIO.direccion = false;

                document
                  .querySelector("#localidadDireccion")
                  .addEventListener("input", function () {
                    DELIO.Mapfre.datalayerInfo["localidad"] =
                      document.querySelector("#localidadDireccion").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
                document
                  .querySelector("#localidadDireccion")
                  .addEventListener("blur", function () {
                    DELIO.Mapfre.datalayerInfo["localidad"] =
                      document.querySelector("#localidadDireccion").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });

                document
                  .querySelector("#tipoDeViaDireccion-input")
                  .addEventListener("click", function () {
                    setTimeout(function () {
                      DELIO.Mapfre.datalayerInfo["tipo_de_via"] =
                        document.querySelector(
                          "#tipoDeViaDireccion-input"
                        ).innerText;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    }, 500);
                  });

                document
                  .querySelector("#nombreDeViaDireccion")
                  .addEventListener("input", function () {
                    DELIO.Mapfre.datalayerInfo["nombre_de_la_via"] =
                      document.querySelector("#nombreDeViaDireccion").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });

                document
                  .querySelector("#numeroDireccion")
                  .addEventListener("input", function () {
                    DELIO.Mapfre.datalayerInfo["numero"] =
                      document.querySelector("#numeroDireccion").value;
                    sessionStorage.wm_datalayerInfo = JSON.stringify(
                      DELIO.Mapfre.datalayerInfo
                    );
                  });
              }
            } else if (window.nombre_pagina === "precio") {
              //TO DO
              if (DELIO.hPrecio) {
                DELIO.hogarSetTrue();
                DELIO.hPrecio = false;

                try {
                  var hogarTuEliges =
                    document.getElementById("referencia200305");
                  var hogarBasico = document.getElementById("referencia200057");
                  var hogarFamiliar =
                    document.getElementById("referencia200058");
                  var hogarTotal = document.getElementById("referencia200059");
                  var hogarPlatino =
                    document.getElementById("referencia200068");
                  if (hogarTuEliges) {
                    if (
                      typeof hogarTuEliges.value != "undefined" &&
                      hogarTuEliges.value !== ""
                    ) {
                      DELIO.Mapfre.datalayerInfo["Cod_Ref_Hogar_Tu_Eliges"] =
                        hogarTuEliges.value;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    }
                  }
                  if (hogarBasico) {
                    if (
                      typeof hogarBasico.value != "undefined" &&
                      hogarBasico.value !== ""
                    ) {
                      DELIO.Mapfre.datalayerInfo["Cod_Ref_Hogar_Basico"] =
                        hogarBasico.value;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    }
                  }
                  if (hogarFamiliar) {
                    if (
                      typeof hogarFamiliar.value != "undefined" &&
                      hogarFamiliar.value !== ""
                    ) {
                      DELIO.Mapfre.datalayerInfo["Cod_Ref_Hogar_Familia"] =
                        hogarFamiliar.value;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    }
                  }
                  if (hogarTotal) {
                    if (
                      typeof hogarTotal.value != "undefined" &&
                      hogarTotal.value !== ""
                    ) {
                      DELIO.Mapfre.datalayerInfo["Cod_Ref_Hogar_Total"] =
                        hogarTotal.value;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        DELIO.Mapfre.datalayerInfo
                      );
                    }
                  }
                  if (hogarPlatino) {
                    if (
                      typeof hogarPlatino.value != "undefined" &&
                      hogarPlatino.value !== ""
                    ) {
                      DELIO.Mapfre.datalayerInfo["Cod_Ref_Hogar_Platino"] =
                        hogarPlatino.value;
                      sessionStorage.wm_datalayerInfo = JSON.stringify(
                        Cod_Ref_Hogar_Platino
                      );
                    }
                  }
                } catch (error) { }
              }
            }
          } catch (error) {
            DELIO.hogarSetTrue();
          }
        }, 250);
      },
    };

    DELIO.Mapfre.setConversionVars = function () {
      /* Producto */
      window.site =
        changeOrigenVida(DELIO.Mapfre.getProduct()) ||
        DELIO.Mapfre.getSiteMapfre();
      window.c_var_4 =
        changeOrigenVida(DELIO.Mapfre.getProduct()) ||
        DELIO.Mapfre.getSiteMapfre();
      /* Origen */
      window.c_var_3 = "formulario";
      window.c_var_0 = DELIO.Mapfre.getUserId();
      //paso

      if (DELIO.Mapfre.getQueryVariable("res")) {
        if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn") {
          womtp.c_vars[11] = "Si_Rec_Presu_Burn";
        } else if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn_b") {
          womtp.c_vars[11] = "Si_Rec_Presu_Burn";
          womtp.c_vars[9] = "Banner";
        } else if (DELIO.Mapfre.getQueryVariable("res") == "rec_burn_h") {
          womtp.c_vars[11] = "Si_Rec_Presu_Burn";
          womtp.c_vars[9] = "Home";
        } else {
          womtp.c_vars[11] = "si";
        }
      }
    };

    DELIO.Mapfre.getUserId = function () {
      var dcuserid;

      if (DELIO.Mapfre.getQueryVariable("dcuserid")) {
        dcuserid = DELIO.Mapfre.getQueryVariable("dcuserid");

        //En ocaciones se anyaden mas parametros separados de almohadilla
        if (dcuserid.indexOf("#") !== -1) {
          dcuserid = dcuserid.split("#")[0];
        }
        //Si no tiene el parametro que devuelva cadena vacia en lugar de false
      } else {
        dcuserid = "";
      }

      return dcuserid;
    };

    DELIO.Mapfre.getVisitorId = function (callback) {
      if (window.Piwik) {
        callback && callback(Piwik.getAsyncTracker().getVisitorId());
        return Piwik.getAsyncTracker().getVisitorId();
      }

      var checkPiwik = setInterval(function () {
        if (window.Piwik) {
          callback && callback(Piwik.getAsyncTracker().getVisitorId());
          clearInterval(checkPiwik);
        }
      }, 200);
    };

    function cobrowsingRepint() {
      var repintCobrowsigWrapper = setInterval(function () {
        if (
          !document.querySelector("#cobrowsingClose-wrapper") &&
          !cobrowsingStop
        ) {
          bodyElement.appendChild(wrapper);
        } else if (cobrowsingStop) {
          clearInterval(repintCobrowsigWrapper);
        }
      }, 1000);
    }
  });

  // !INICIO: Añade showImpression cuando se clica el botón te llamamos del header

  const clearReaload = (callback, flag, action) => {
    window[flag] && action();
    callback();
  };

  window.addShowImpression = () => {
    const showImpressionInterval = setInterval(() => {
      const callYouBtn = document.querySelector(".DCS-ClickToCall");

      if (document.readyState === "complete" && callYouBtn) {
        clearInterval(showImpressionInterval);
        callYouBtn.addEventListener("click", () => {
          const { textContent } = document.querySelector(
            ".DCS-textClickToCall"
          );
          showImpression(textContent);
          console.log("haciendo impresión en " + textContent);
        });
      }
    });
  };

  if (window.site === "bici") {
    clearReaload(
      () => (window.showImpressionBici = true),
      "showImpressionBici",
      addShowImpression
    );
  } else {
    addShowImpression();
  }
  // !CIERRE: Añade showImpression cuando se clica el botón te llamamos del header

  if (
    window.location.href.indexOf(
      "final.preeurasiabk.mapfre.com/calcular-seguro-salud-global"
    ) ||
    window.location.href.indexOf(
      "wmapfre.pre.mapfre.net/calcular-seguro-salud-global"
    ) ||
    window.location.href.indexOf(
      "final.preeurasiabk.mapfre.com/calcular-seguro-hogar"
    ) ||
    window.location.href.indexOf("wmapfre.pre.mapfre.net/calcular-seguro-hogar")
  ) {
    let numberExist = setInterval(function () {
      if (
        document.getElementsByClassName("mfc-footer__main--list-icon-links")[0]
      )
        var footerPhone = document.getElementsByClassName(
          "mfc-footer__main--list-icon-links"
        )[0];
      if (footerPhone) {
        clearInterval(numberExist);
        var date = new Date();
        var now = date.getHours();
        var day = date.getDay();
        var inScheduleWeek = now >= 9 && now <= 20 && day <= 5;
        footerPhone.style.display = "none";

        if (inScheduleWeek) {
          footerPhone.style.display = "inline-block";
        }
      }
    }, 1000);
  }

  //Hide RP Comunidades TF

  const waitClass = setInterval(function () {
    if (window.location.href.indexOf("MAPGEN_OIMCOMUNI") > -1) {
      let rpContainer = document.getElementsByClassName(
        "DCS-bodyRpContainer"
      )[0];
      if (rpContainer) {
        clearInterval(waitClass);
        rpContainer.style.display = "none";
        document.getElementsByClassName("DCS-bodyRpText")[0].style.display =
          "none";
        document.getElementsByClassName(
          "DCS-footerFormButton"
        )[0].style.marginTop = "10px";
      }
    }
  }, 1000);

  //Ocultar segundo Ringpool

  if (DELIO.Mapfre.getProduct() === "accidentes") {
    if (screen.width < 786) {
      var waitEl = setInterval(function () {
        if (document.getElementsByClassName("DCS-ClickToCall")[2]) {
          clearInterval(waitEl);
          Array.from(document.getElementsByClassName("DCS-RP")).forEach(
            (e) => (e.style.display = "none")
          );
          if (document.getElementById("walmeric")) {
            document.getElementById("walmeric").style.marginTop = "2px";
            document.getElementById("walmeric").style.display = "block";
          }
        }
      }, 500);
    }
  }

  if (window.site == "coche") {
    const intervalModalCoche = setInterval(() => {
      if (
        document.readyState === "complete" &&
        document.querySelector(".DCS-footerFormButton") &&
        document.querySelector(".DCS-phone-coche")
      ) {
        clearInterval(intervalModalCoche);
        document.querySelector(".DCS-footerFormButton").disabled = true;
        const varInputTelefonoModalCoche =
          document.querySelector(".DCS-phone-coche");
        varInputTelefonoModalCoche.addEventListener("input", function () {
          if (varInputTelefonoModalCoche.value.length >= 9) {
            document.querySelector(".DCS-footerFormButton").disabled = false;
          } else {
            document.querySelector(".DCS-footerFormButton").disabled = true;
          }
        });
      }
    });
  } else if (window.site == "moto") {
    const intervalModalMoto = setInterval(() => {
      if (
        document.readyState === "complete" &&
        document.querySelector(".DCS-footerFormButton") &&
        document.querySelector(".DCS-phone-moto")
      ) {
        clearInterval(intervalModalMoto);
        document.querySelector(".DCS-footerFormButton").disabled = true;
        const varInputTelefonoModalMoto =
          document.querySelector(".DCS-phone-moto");
        varInputTelefonoModalMoto.addEventListener("input", function () {
          if (varInputTelefonoModalMoto.value.length >= 9) {
            document.querySelector(".DCS-footerFormButton").disabled = false;
          } else {
            document.querySelector(".DCS-footerFormButton").disabled = true;
          }
        });
      }
    });
  }

  if (window.site.toLowerCase() == "coche" || window.site.toLowerCase() == "moto" || window.site.toLowerCase() == "hogar") {

    const mutationDate = new MutationObserver(() => {
      const container = document.getElementsByClassName("date_text")[0];

      if (container) {
        container.innerHTML = "L - V 9:00 - 22:00h | S 9:00-14:00h";
        mutationDate.disconnect();
      }

    })

    mutationDate.observe(document.body, { subtree: true, childList: true });
  }

  //Interceptar botón "Recibir una llamada" en paso precio en tarificador Accidentes
  const waitShowModal = setInterval(() => {
    if (
      window.location.href ==
      "https://precio.mapfre.es/calcular-seguro-accidentes/es/calculo-de-cuota"
    ) {
      if (
        document.querySelectorAll(
          ".mfc-link-button__container.ng-binding.ng-scope"
        )[1] != "undefined"
      ) {
        clearInterval(waitShowModal);
        document.querySelectorAll(
          ".mfc-link-button__container.ng-binding.ng-scope"
        )[1].innerHTML = `
            <div class="mfc-link-button__tag ng-scope mfc-price-box__button mfc-price-box__button--white mfc-link-button__has--not-icon btn-recibir-llamada">Recibir una llamada</div>
            `;
        document
          .querySelector(".btn-recibir-llamada")
          .addEventListener("click", (e) => {
            D3P.Modal.open();
          });
      }
    }
  }, 800);

  function btnWalmericMobile() {
    var btns = document.querySelectorAll(".btn-walmeric");
    // Agregar controlador de eventos "click" a cada botón

    btns.forEach((btn) => {
      if (window.matchMedia("(max-width: 980px)").matches) {
        if (btn.hasAttribute("data-modal")) {
          btn.removeAttribute("data-modal");
        }
        if (btn.hasAttribute("data-trigger-click")) {
          btn.removeAttribute("data-trigger-click");
        }
        if (btn.hasAttribute("href")) {
          btn.removeAttribute("href");
        }
        console.log("mobile" + document.querySelectorAll(".btn-walmeric"));
        const nuevoBtnWalmeric = btn.cloneNode(true);
        btn.replaceWith(nuevoBtnWalmeric);

        nuevoBtnWalmeric.addEventListener(
          "click",
          function () {
            if (nuevoBtnWalmeric.hasAttribute("data-trigger-click")) {
              nuevoBtnWalmeric.removeAttribute("data-trigger-click");
            }
            if (nuevoBtnWalmeric.hasAttribute("href")) {
              nuevoBtnWalmeric.removeAttribute("href");
            }
            if (nuevoBtnWalmeric.hasAttribute("data-modal")) {
              nuevoBtnWalmeric.removeAttribute("data-modal");
            }
            D3P.Modal.open();
          },
          true
        );
      }
    });
  }

  function interceptarBtnWalmeric() {
    // Seleccionar todos los elementos con la clase ".btn-walmeric"
    var btns = document.querySelectorAll(".btn-walmeric");
    // Agregar controlador de eventos "click" a cada botón

    btns.forEach((btn) => {
      if (btn.hasAttribute("href")) {
        btn.removeAttribute("href");
      }
      if (btn.hasAttribute("data-trigger-click")) {
        btn.removeAttribute("data-trigger-click");
      }
      if (btn.hasAttribute("data-modal")) {
        btn.removeAttribute("data-modal");
      }

      if (window.matchMedia("(max-width: 980px)").matches) {
        console.log("despues" + document.querySelectorAll(".btn-walmeric"));
        const nuevoBtnWalmeric = btn.cloneNode(true);
        btn.replaceWith(nuevoBtnWalmeric);
        nuevoBtnWalmeric.addEventListener(
          "click",
          function () {
            if (nuevoBtnWalmeric.hasAttribute("data-trigger-click")) {
              nuevoBtnWalmeric.removeAttribute("data-trigger-click");
            }
            if (nuevoBtnWalmeric.hasAttribute("href")) {
              nuevoBtnWalmeric.removeAttribute("href");
            }
            if (nuevoBtnWalmeric.hasAttribute("data-modal")) {
              nuevoBtnWalmeric.removeAttribute("data-modal");
            }
            D3P.Modal.open();
          },
          true
        );
      }

      btn.addEventListener(
        "click",
        function () {
          console.log("click");
          if (btn.hasAttribute("data-trigger-click")) {
            btn.removeAttribute("data-trigger-click");
          }
          if (btn.hasAttribute("href")) {
            btn.removeAttribute("href");
          }
          if (btn.hasAttribute("data-modal")) {
            btn.removeAttribute("data-modal");
          }
          D3P.Modal.open();
        },
        true
      );
    });
  }
  if (window.location.href.includes("particulares")) {
    if (document.querySelector(".hero_sticky_button_phone")) {
      const btnObservable = document.querySelector(".hero_sticky_button_phone");
      btnObservable.addEventListener("click", () => {
        console.log(
          "click",
          document.querySelector(".hero_sticky_button_phone")
        );

        function observeFourthButton() {
          const buttons = document.querySelectorAll(".btn-walmeric");

          if (buttons.length >= 4) {
            // Cuarto elemento .btn-walmeric encontrado
            const fourthButton = buttons[3];
            console.log(
              "El cuarto elemento .btn-walmeric ha sido encontrado:",
              fourthButton
            );
            // Aquí puedes realizar las acciones necesarias
            btnWalmericMobile();
            // Detener la observación después de encontrar el cuarto elemento
            observer.disconnect();
            return;
          }
        }

        const observer = new MutationObserver(observeFourthButton);
        observer.observe(document.body, { childList: true, subtree: true });
        const newElement = document.createElement("input");
        newElement.setAttribute("type", "hidden");
        document.body.appendChild(newElement);
      });
    }
  }
})();



// WEBPACK FOOTER //
// ./js/entornoMapfreSP.js